import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  Inject,
  PLATFORM_ID,
  ViewChild,
  Output,
  EventEmitter,
  HostListener,
  AfterViewInit
} from '@angular/core';
import { NzResizeEvent } from 'ng-zorro-antd/resizable';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { NzInputDirective } from 'ng-zorro-antd/input';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import {SERVICE_CONFIG, TaskService} from '../../services/task.service';
import {DatePipe} from '@angular/common';
import {HttpClient} from '@angular/common/http';
import {UtilsModule} from '../../utils/utils.module';
import { NgxPermissionsService } from 'ngx-permissions';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ResizeEvent} from 'angular-resizable-element';
import { BehaviorSubject, Observable, of, fromEvent, Subscription, } from 'rxjs';
import { catchError, debounceTime, map, switchMap } from 'rxjs/operators';
@Component({
  selector: 'task-log-grid',
  templateUrl: './log-grid.component.html',
  styleUrls: ['./log-grid.component.less'],
  providers: [TaskService, DatePipe]
})
export class LogGridComponent implements OnInit, AfterViewInit, OnDestroy {
  dataSubscription: Subscription = null;
  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据
  boardId = null; // 存放面板ID
  boardWidth: number; // 面板宽度
  visibleHeight: number; // 可视区域高度
  selectedIndex = 0; // 标签页默认激活
  mapOfExpandedData: any;
  listOfMapData = [];
  activeGroup: any; // 当前活动分组
  isLoading = false;
  editNameId: string | null; // 编辑ID
  originalValue: string;
  isSpinning = false;
  groupAuthority: any = {
    edit: {
      status: false,
      members: []
    },
    view: {
      status: false,
      members: []
    }
  };
  initGroupColor = [
    'rgb(3, 127, 76)',
    'rgb(0, 200, 117)',
    'rgb(156, 211, 38)',
    'rgb(202, 182, 65)',
    'rgb(255, 203, 0)',
    'rgb(120, 75, 209)',
    'rgb(0, 134, 192)',
    'rgb(87, 155, 252)',
    'rgb(102, 204, 255)',
    'rgb(187, 51, 84)',
    'rgb(226, 68, 92)',
    'rgb(255, 21, 138)',
    'rgb(255, 90, 196)',
    'rgb(255, 100, 46)',
    'rgb(253, 171, 61)',
    'rgb(127, 83, 71)',
    'rgb(100,127,120)',
    'rgb(196, 196, 196)',
    'rgb(128, 128, 128)',
    'rgb(51, 51, 51)'
  ]; // group默认组颜色
  pulseCheckedId = []; // 选中行ID
  pulseCheckedData: any = {}; // 行选中数据
  confirmModal: NzModalRef; // 确认框
  tplModal: NzModalRef;
  isConfirmLoading = false; // 批量修改弹窗提交按钮状态
  clickCurrentColumnValue = null; // 是否点击当前列
  clickCurrentPulseValue = null; // 是否点击当前行
  isMemberVisible = false; // 选择成员
  currentColumnData: any; // 存放当前列数据
  currentColumnId = ''; // 当前列ID
  filterConditionCount = 0;
  filterData = {
    groups: [],
    selectedGroups: [],
    columns: []
  };
  filterColumnExclude = ['progress', 'time-interval', 'relation-data', 'button', 'vote']; // 不支持筛选的列
  // 批量设置成员
  isBatchAddMemberVisible = false;
  total: number;
  pageIndex = 1;
  pageSize = 999;
  searchKey;
  getBoardUserList: Observable<any>;
  loadMoreData = true;
  memberList: Array<any> = [];
  randomUserUrl: string;
  selectedMemberValue: Array<any> = [];
  selectedTaskValue: Array<any> = [];
  lastColumn: any;
  isDialogVisible = false; // 会话窗口开启状态
  conversationBaseData: any = {}; // 会话窗口基础数据
  currentUser: any; // 存放当前用户信息
  buttonConfigStatus = true; // 按钮配置项显示状态
  buttonConfigTitle = null; // 按钮配置-标题
  buttonConfigDisabled = true; // 按钮配置-是否可用
  buttonConfigUrl = null; // 按钮配置-url
  isExternalUrl = false; // 是否外部地址
  buttonConfigEditStatus = false; // 按钮配置-是否编辑状态
  buttonConfigEditeData: any = {}; // 按钮配置-存放当前编辑项数据
  clickButtonLoading: boolean; // 按钮配置 - 按钮loading
  progressSubmitState = false; // 进度分配提交按钮状态
  isAddTaskVisible = false;  // 添加任务
  createWayType = null;  // 任务创建方式
  taskRulesOption = []; // 存放任务池数据
  taskRulesValue = null; // 选中任务池规则
  taskRelationProduct: any; // 选择关联产品
  productOption = []; // 产品列表
  addTaskForm = this.fb.group({
    groupId: [null, [Validators.required]],
    parentId: [null],
    taskDate: [],
    name: [null, [Validators.required]]
  });
  parentTaskData = []; // 存放父级任务数据
  permissionDefinition: any; // 存放面板权限配置
  movePulsePopVisible = false;
  isBatchAddMemberLoading = false;
  // 任务状态设置
  isAddStatusListVisible = false;
  statusOptionData = [];
  statusItemList = [];
  currentStatusItem: any;
  currentStatusList: any;
  isAddStatusItemVisible = false;
  addItemForm: FormGroup = this.fb.group({
    index: [null, [Validators.required]],
    label: [null, [Validators.required]],
    color: [null, [Validators.required]],
    event: [null],
    url: [null],
    symbol: [null]
  });
  isEditStatusItem = false;
  currentPanelColor = 'rgba(255,255,255, 1)';
  taskStatusList = [];
  initColor = [
    'rgb(253, 171, 61)',
    'rgb(0, 200, 117)',
    'rgb(226, 68, 92)',
    'rgb(87, 155, 252)',
    'rgb(159 165 165)',
    'rgb(255, 100, 46)',
    'rgb(0, 134, 192)',
    'rgb(162, 93, 220)',
    'rgb(127, 83, 71)',
    'rgb(255, 90, 196)',
    'rgb(255, 21, 138)',
    'rgb(187, 51, 84)',
    'rgb(3, 127, 76)',
    'rgb(255, 203, 0)',
    'rgb(202, 182, 65)',
    'rgb(156, 211, 38)'
  ];
  // 任务规则管理
  isTaskRulesVisible = false;
  taskStatisticsVisible = false;
  boardStatisticList = [];
  taskRuleRelevance: string;
  searchChange$ = new BehaviorSubject('');
  isProductLoading = false;
  productUrl = '/v1/prod_products';
  isLoadMoreData = true;
  getProductList: Observable<any>;
  productPageIndex = 1;
  productPageSize = 20;
  selectProductList = [];
  isProductVisible = false;
  // 产品表格
  checked = false;
  indeterminate = false;
  listOfCurrentPageData = [];
  productListOfData = [];
  setOfCheckedId = new Set<number>();
  productPageTotal = 0;
  searchProductValue = null;
  // 修改组名弹窗
  isEditGroupNameVisible = false;
  currentEditGroupName: string;
  currentEditBoardId: string;
  currentEditGroupId: string;
  currentEditGroupColor: string;
  // 修改名称弹窗
  isEditColumnNameVisible = false;
  isEditPulseNameVisible = false;
  // 任务系统参数
  taskSystemParameter: any;
  // 日志操作组件配置
  taskDataDate: string;
  currentPulseData: any; // 当前任务数据
  auditModalVisible = false;
  monitorModalVisible = false;
  auditList: any  = []; // 稽核列表
  monitorList: any  = []; // 监控列表
  checkVisible = false; // 检查项详情
  checkMonitorVisible = false;
  // 稽核来源
  outSystems: any = {
    yhfin: '赢和'
  };
  auditItemIdList = [];
  indicatorItemIdList = [];
  reportVisible = false;
  taskReportConfig: any;
  scanAuditTimer: any; // 扫描轮询
  scanMonitorTimer: any; // 扫描轮询
  editId: string | null = null;
  // 任务状态标记
  taskStatusSymbol = [
    {
      label: '完成',
      value: 'complete'
    },
    {
      label: '异常',
      value: 'abnormal'
    }
  ];
  levelNumber = 0; // 折叠最大层级数
  levelList = []; // 折叠列表
  @ViewChild('checkList') checkList;
  @ViewChild('ratioSuperisory') ratioSuperisory: any;
  @Input('nfData') set ChangeData(data: any) {
    if (JSON.stringify(data) !== '{}') {
      this.boardData = data;
      this.handleBoardList(this.boardData);
    }
  }
  @ViewChild('modalTplContent', { static: true }) modalTplContent: any;
  @ViewChild('tplFooter', { static: true }) tplFooter: any;
  @ViewChild('pulseCard') pulseCard: any;
  @Output() nfUpdateTable: EventEmitter<any> = new EventEmitter<any>();
  @Input() showFilter = false;
  @Input('taskSystemParameter') set ChangeParam(data: any) {
    if (data) {
      this.taskSystemParameter = data;
    }
  }
  constructor(
    private taskService: TaskService,
    private message: NzMessageService,
    private modal: NzModalService,
    private http: HttpClient,
    private utilsModule: UtilsModule,
    private datePipe: DatePipe,
    private fb: FormBuilder,
    private permissionsService: NgxPermissionsService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit(): void {
    const productBaseApi = SERVICE_CONFIG.environment && SERVICE_CONFIG.environment.hasOwnProperty('productModule') && SERVICE_CONFIG.environment['productModule'] ? SERVICE_CONFIG.environment['productModule'] : '';
    this.productUrl = productBaseApi + this.productUrl;
  }
  ngAfterViewInit() {
    this.taskDataDate = localStorage.getItem('taskDataDate');
  }
  ngOnDestroy(): void {
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
  }
  @HostListener('window:click', ['$event'])
  handleClick(e: MouseEvent): void {
    if (this.clickCurrentColumnValue && this.hasClass(e.target, 'board-wrapper')) {
      this.clickCurrentColumnValue = null;
    }
    if (this.clickCurrentPulseValue && this.hasClass(e.target, 'board-wrapper')) {
      this.clickCurrentPulseValue = null;
    }
    if (this.editId && this.hasClass(e.target, 'board-wrapper')) {
      this.editId = null;
    }
  }
  // 处理面板数据
  handleBoardList(data) {
    this.boardId = data.id;
    this.boardGroupData = data.boardData.groups ? data.boardData.groups : [];
    this.boardColumnData = data.boardData.columns ? data.boardData.columns : [];
    this.boardPulseData = data.boardData.pulses ? data.boardData.pulses : [];
    // 处理文本框默认值为null字符串的问题
    this.boardColumnData.forEach(c => {
      if (c.type === 'text') {
        this.boardPulseData.forEach(p => {
          if (p.columnValues[c.id] === 'null') {
            p.columnValues[c.id] = null;
          }
        });
      }
    });
    this.permissionDefinition = data.permissionDefinition;
    this.currentUser = data.boardData.currentUser;
    this.listOfMapData = [];
    this.mapOfExpandedData = {};
    const _tabSelectIndex = localStorage.getItem('tabSelectedIndex');
    if (_tabSelectIndex !== null && _tabSelectIndex !== 'null') {
      this.selectedIndex = Number(_tabSelectIndex);
    }
    this.getActiveGroup(this.boardGroupData[this.selectedIndex]);
    this.getVisibleSize();
    this.calcFilterData();
    this.boardStatisticData();
    // load permissions
    this.permissionsService.loadPermissions(this.currentUser.permissions ? this.currentUser.permissions : []);
  }
  // 平级转树形数据
  listConvertTree(data) {
    // 没有父节点的数据
    const parents = data.filter(value => value.parentId === 'undefined' || value.parentId == null);
    // 有父节点的数据
    const children = data.filter(value => value.parentId !== 'undefined' && value.parentId != null);
    const translator = (parents, children) => {
      // 遍历父节点数据
      parents.forEach((parent) => {
          // 遍历子节点数据
        children.forEach((current, index) => {
            // 此时找到父节点对应的一个子节点
            if (current.parentId === parent.id) {
              // 对子节点数据进行深复制，这里只支持部分类型的数据深复制
              const temp = JSON.parse(JSON.stringify(children));
              // 让当前子节点从temp中移除，temp作为新的子节点数据，这里是为了让递归时，子节点的遍历次数更少，如果父子关系的层级越多，越有利
              temp.splice(index, 1);
              // 让当前子节点作为唯一的父节点，去递归查找其对应的子节点
              translator([current], temp);
              // 把找到子节点放入父节点的children属性中
              if (parent.children && parent.children.length) {
                parent.children.push(current);
                parent.children = this.duplicateRemoval(parent.children);
              } else {
                parent.children = [current];
              }
              // typeof parent.children !== 'undefined' ? parent.children.push(current) : parent.children = [current];
            }
          });
        }
      );
    };
    translator(parents, children);
    return parents;
  }
  collapse(_array, data, $event: boolean): void {
    if (!$event) {
      if (data.children) {
        data.children.forEach(d => {
          const target = _array.find(a => a.id === d.id)!;
          target.expand = false;
          this.collapse(_array, target, false);
        });
      } else {
        return;
      }
    }
  }
  // 树形转平级数据
  convertTreeToList(root) {
    const stack = [];
    const array = [];
    const hashMap = {};
    const expand = localStorage.getItem('groupFoldStatus');
    let state = true;
    if (expand === 'unfold') {
      state = true;
    } else if (expand === 'fold') {
      state = false;
    }
    stack.push({ ...root, level: 0, expand: state });
    while (stack.length !== 0) {
      const node = stack.pop()!;
      this.visitNode(node, hashMap, array);
      if (node.children) {
        for (let i = node.children.length - 1; i >= 0; i--) {
          stack.push({ ...node.children[i], level: node.level! + 1, expand: state, parent: node });
        }
      }
    }
    return array;
  }
  visitNode(node, hashMap: { [id: string]: boolean }, array): void {
    if (!hashMap[node.id]) {
      hashMap[node.id] = true;
      array.push(node);
    }
  }
  getActiveGroup(group) {
    this.isSpinning = true;
    const pulse = this.boardPulseData.filter(d => d.groupId === group.id);
    setTimeout(() => {
      this.activeGroup = group;
      this.listOfMapData = this.listConvertTree(pulse);
      this.listOfMapData = this.duplicateRemoval(this.listOfMapData);
      this.pulseCheckedId = [];
      group['levelNumber'] = 0;
      group['levelList'] = [];
      this.listOfMapData.forEach(item => {
        item.isPulseOpenSelection = false;
        this.mapOfExpandedData[item.id] = this.convertTreeToList(item);
        this.getTreeGridMaxLevel(this.mapOfExpandedData[item.id], group);
      });
      this.isSpinning = false;
    }, 100);
  }
  clickGroupMenu(event, group) {
    if (event) {
      event.stopPropagation();
    }
    group['levelNumber'] = 0;
    group['levelList'] = [];
    let groupPulses = this.listConvertTree(group.pulses);
    groupPulses = this.duplicateRemoval(groupPulses);
    groupPulses.forEach(item => {
      this.getTreeGridMaxLevel(this.convertTreeToList(item), group);
    });
  }
  duplicateRemoval(data) {
    let _data = data;
    if (_data && _data.length) {
      const obj = {};
      _data = data.reduce((cur, next) => {
        obj[next.id] ? '' : obj[next.id] = true && cur.push(next);
        return cur;
      }, []);
      _data.forEach(item => {
        if (item.children && item.children.length) {
          this.duplicateRemoval(item.children);
        }
      });
    }
    return _data;
  }
  // 获取可视区域宽度
  getVisibleSize() {
    const visibleContainer = document.getElementById('first-level-content');
    if (visibleContainer) {
      this.visibleHeight = visibleContainer.offsetHeight - 180;
    }
  }
  // 添加分组
  addNewGroup(boardId) {
    const color = this.utilsModule.getRandomColor();
    const param = {};
    param['title'] = '新组';
    param['color'] = color;
    this.dataSubscription = this.taskService.doAddGroup(boardId, param).subscribe((res: any) => {
      if (res) {
        const groupObj = {
          'title': res.title,
          'color': res.color,
          'id': res.id,
          'boardId': res.boardId
        };
        this.boardGroupData = [
          groupObj,
          ...this.boardGroupData
        ];
        this.nfUpdateTable.emit(true);
      }
    });
  }
  // 添加组列
  addColumnFun(boardId, type, name) {
    const param = {
      type: type,
      title: name
    };
    this.dataSubscription = this.taskService.doAddColumn(boardId, param).subscribe((res: any) => {
      if (res) {
        const obj = JSON.parse(res.definition);
        this.nfUpdateTable.emit(true);
        this.setProgressValue();
        if (obj) {
          this.addFilterColumn(obj);
        }
      }
    });
  }
  addFilterColumn(source) {
    if (this.filterColumnExclude.includes(source.type)) {
      return;
    }
    this.filterData.columns.push({
      columnId: source.id,
      type: source.type,
      name: source.title,
      maxHeight: '240px',
      valueMaxHeight: '',
      columnValues: [{title: '', value: '', count: this.boardPulseData.length}],
      selectedValue: []
    });
  }
  // 进度条组件-进度赋值
  setProgressValue() {
    let count = 0;
    this.boardColumnData.forEach((item, index) => {
      if (item.type === 'status' && item.checked) {
        count = count + 1;
      }
    });
    let i = count;
    this.boardColumnData.forEach((item, index) => {
      if (item.type === 'status' && item.checked && i >= 0) {
        item.value = this.progressAverage(count)[count - i];
        i = i - 1;
      }
    });
    this.progressCalcValue();
  }
  // 平均分配
  progressAverage(count) {
    const value = [];
    let remainder = 100 % count;
    if (remainder === 0) {
      for (let i = 0; i < count; i++) {
        value.push(100 / count);
      }
    } else {
      for (let i = 0; i < count; i++) {
        if (remainder !== 0) {
          value.push(parseInt(((100 / count) + 1).toString(), 0));
          remainder = remainder - 1;
        } else {
          const num = 100 / count;
          value.push( parseInt(num.toString(), 0) );
        }
      }
    }
    return value;
  }
  // 进度条组件-复选框选中事件
  progressCheckboxChange(event) {
    const data = event;
    for (let i = 0; i < this.boardColumnData.length; i++) {
      if (this.boardColumnData[i].type === 'status') {
        this.boardColumnData[i].checked = false;
      }
    }
    if (data.length > 0) {
      for (let i = 0; i < this.boardColumnData.length; i++) {
        if (this.boardColumnData[i].type === 'status') {
          for (let j = 0; j < data.length; j++) {
            if (data[j] === this.boardColumnData[i].id) {
              this.boardColumnData[i].checked = true;
              this.progressSubmitState = false;
            }
          }
        }
      }
    } else {
      for (let j = 0; j < this.boardColumnData.length; j++) {
        if (this.boardColumnData[j].type === 'status') {
          this.boardColumnData[j].checked = false;
          this.progressSubmitState = true;
        }
      }
    }
    this.setProgressValue();
  }
  // 进度条组件-提交设置
  submitProgressConfig() {
    let value = 0;
    for (let i = 0; i < this.boardColumnData.length; i++) {
      if (this.boardColumnData[i].type === 'status' && this.boardColumnData[i].checked) {
        value = value + Number(this.boardColumnData[i].value);
      }
    }
    if (value > 100) {
      this.message.create('error', '总数不能超过100%！');
      return false;
    } else {
      // 提交
      this.progressCalcValue();
    }
  }
  // 进度条组件-根据进度分配权重计算进度值
  progressCalcValue() {
    const value = [];
    const progressId = [];
    for (const key in this.boardColumnData) {
      if (this.boardColumnData.hasOwnProperty(key)) {
        if (this.boardColumnData[key].type === 'status' && this.boardColumnData[key].value && this.boardColumnData[key].checked) {
          const o = {
            key: this.boardColumnData[key].id,
            value: Number(this.boardColumnData[key].value)
          };
          value.push(o);
        }
        if (this.boardColumnData[key].type === 'progress') {
          progressId.push(this.boardColumnData[key].id);
        }
      }
    }
    for (let i = 0; i < this.boardPulseData.length; i++) {
      let num = 0;
      for (const key in this.boardPulseData[i].columnValues) {
        if (this.boardPulseData[i].columnValues.hasOwnProperty(key)) {
          for (let j = 0; j < progressId.length; j++) {
            if (progressId[j] === key) {
              this.boardPulseData[i].columnValues[key] = 0;
            }
          }
        }
      }
      for (let j = 0; j < value.length; j++) {
        if (this.boardPulseData[i].columnValues[value[j].key] && this.boardPulseData[i].columnValues[value[j].key].index === 2) {
          num = num + value[j].value;
          for (const key in this.boardPulseData[i].columnValues) {
            if (this.boardPulseData[i].columnValues.hasOwnProperty(key)) {
              for (let k = 0; k < progressId.length; k++) {
                if (progressId[k] === key) {
                  if (num > 100) {
                    num = 100;
                  } else if (num < 0) {
                    num = 0;
                  }
                  this.boardPulseData[i].columnValues[key] = num;
                }
              }
            }
          }
        }
      }
    }
  }
  onResize({ width }: NzResizeEvent, column): void {
    if (this.boardData.boardData && this.boardData.boardData.currentUser
      && this.boardData.boardData.currentUser.permissions && this.boardData.boardData.currentUser.permissions.includes('owner')) {
      column.width = width;
      this.taskService.doEditColumnHeader(this.boardId, column.id, {width: column.width}).subscribe(res => {});
    }
  }
  // 列拖动
  columnDrop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.boardColumnData, event.previousIndex + 1, event.currentIndex + 1);
  }
  // 行拖动
  pulseDrop(event: CdkDragDrop<string[]>): void {
    moveItemInArray(this.listOfMapData, event.previousIndex, event.currentIndex);
  }
  // 修改分组名称
  modifyGroupName(title, boardId, groupId, color) {
    const param = {
      title: title,
      color: color
    };
    this.editNameId = null;
    if (this.originalValue !== title) {
      this.dataSubscription = this.dataSubscription = this.taskService.doEditGroupTitle(boardId, groupId, param).subscribe((res: any) => {
        if (res && res.title) {
          this.originalValue = res.title;
        }
      });
    }
  }
  // 修改列名称
  modifyColumnName(title, boardId, columnId) {
    const param = {
      title: title
    };
    this.editNameId = null;
    if (this.originalValue !== title) {
      this.dataSubscription = this.taskService.doEditColumnHeader(boardId, columnId, param).subscribe((res: any) => {
        this.originalValue = res.title;
      });
    }
  }
  // 处理分组权限
  groupAuthorityChange(groupId, visible) {
    if (visible) {
      this.taskService.getGroupAuthority(this.boardId, groupId).subscribe(res => {
        if (res) {
          this.groupAuthority = res;
        }
      });
    }
  }
  getAuthorityMember(target, value) {
    target.members = value;
  }
  groupAuthorityConfirm(group) {
    this.taskService.setGroupAuthority(this.boardId, group.id, this.groupAuthority).subscribe(res => {
      if (res) {
        group['visible'] = false;
      } else {
        this.message.error('提交失败！');
      }
    });
  }
  // 归档组
  archiveGroup(boardId, groupId) {
    this.dataSubscription = this.taskService.doDeleteGroup(boardId, groupId, {}).subscribe((res: any) => {
      this.boardGroupData = this.boardGroupData.filter(d => d.id !== groupId);
    });
  }
  // 更换组颜色
  changeGroupColor(boardId, groupId, color) {
    const param = {
      color: color
    };
    this.boardGroupData.forEach((item, index) => {
      if (item.id === groupId) {
        item.color = color;
      }
    });
    this.dataSubscription = this.taskService.doEditGroupTitle(boardId, groupId, param).subscribe((res: any) => {});
  }
  // 删除组
  removeGroup(boardId, groupId) {
    const param = {
      'destroy': 'true'
    };
    this.dataSubscription = this.taskService.doDeleteGroup(boardId, groupId, param).subscribe((res: any) => {
      this.boardGroupData = this.boardGroupData.filter(d => d.id !== groupId);
      this.pulseCheckedId = [];
    });
  }
  // 行选中事件
  pulseCheckedChange(pulse) {
    pulse.isPulseChecked = !pulse.isPulseChecked;
    if (this.mapOfExpandedData[pulse.id]) {
      this.mapOfExpandedData[pulse.id].forEach((item) => {
        item.isPulseChecked = pulse.isPulseChecked ? true : false;
        if (item.isPulseChecked) {
          this.pulseCheckedId.push(item.id);
        } else {
          this.pulseCheckedId = this.pulseCheckedId.filter(d => d !== item.id);
        }
      });
    } else {
      for (const item in this.mapOfExpandedData) {
        if (this.mapOfExpandedData.hasOwnProperty(item)) {
          this.mapOfExpandedData[item].forEach((_child) => {
            if (_child.id === pulse.id) {
              _child.isPulseChecked = pulse.isPulseChecked ? true : false;
            } else if (_child.parentId === pulse.id) {
              _child.isPulseChecked = pulse.isPulseChecked ? true : false;
            }
            if (_child.isPulseChecked) {
              this.pulseCheckedId.push(_child.id);
            } else {
              this.pulseCheckedId = this.pulseCheckedId.filter(d => d !== _child.id);
            }
          });
        }
      }
    }
    if (pulse.isPulseChecked) {
      this.pulseCheckedId.push(pulse.id);
    } else {
      this.pulseCheckedId = this.pulseCheckedId.filter(d => d !== pulse.id);
    }
    const o = {
      isDelete: true,
      pulseIds: this.pulseCheckedId
    };
    this.pulseCheckedData = o;
    this.listOfMapData.forEach(item => {
      item.isPulseOpenSelection = this.pulseCheckedId && this.pulseCheckedId.length > 0 ? true : false;
    });
    this.pulseCheckedId = Array.from(new Set(this.pulseCheckedId));
  }
  // 关闭批量操作浮动菜单
  closeBatchMenu() {
    this.pulseCheckedId = [];
    this.pulseCheckedData.pulseIds = [];
    this.listOfMapData.forEach((item) => {
      item.isDelete = false;
      item.isPulseOpenSelection = false;
      item.isPulseChecked = false;
    });
    for (const item in this.mapOfExpandedData) {
      if (this.mapOfExpandedData.hasOwnProperty(item)) {
        this.mapOfExpandedData[item].forEach(_i => {
          _i.isDelete = false;
          _i.isPulseOpenSelection = false;
          _i.isPulseChecked = false;
        });
      }
    }
  }
  // 批量编辑
  batchEditPulse() {
    this.tplModal = this.modal.create({
      nzContent: this.modalTplContent,
      nzMaskClosable: false,
      nzFooter: this.tplFooter,
      nzTitle: null,
      nzWidth: '30%',
      nzWrapClassName: 'vertical-center-modal',
    });
  }
  // 批量编辑弹窗按钮事件
  handleAddCancel() {
    this.tplModal.destroy();
  }
  handleAddOk() {
    this.pulseCard.onSubmit();
  }
  getPulseCardData(data) {
    if (data.columnValues && data.columnValues.length > 0) {
      this.isConfirmLoading = true;
      this.dataSubscription = this.taskService.batchChangeColumn(this.boardId, data).subscribe((res: any) => {
        this.isConfirmLoading = false;
        this.message.create('success', '更新成功！');
        this.nfUpdateTable.emit(true);
        this.tplModal.destroy();
        this.pulseCheckedId = [];
      }, (err) => {
        this.isConfirmLoading = false;
        this.message.create('error', '更新失败！');
      });
    } else {
      this.message.create('info', '无修改项！');
    }
  }
  // 批量移动
  batchMoveToGroup(group) {
    let state = false;
    this.pulseCheckedId.forEach((item, index) => {
      if (this.checkTreeData(item)) {
        state = true;
      }
    });
    if (state) {
      this.confirmModal = this.modal.confirm({
        nzTitle: '移动的父级任务不能含有未选中的子任务，请检查。',
        nzWrapClassName: 'vertical-center-modal',
        nzOkText: null
      });
    } else {
      this.taskService.moveToGroup(this.boardId, {groupId: group.id, pulseIds: this.pulseCheckedId}).subscribe(res => {
        if (res) {
          for (const pulse of this.boardPulseData) {
            if (this.pulseCheckedId.includes(pulse.id)) {
              pulse.groupId = group.id;
            }
          }
          this.closeBatchMenu();
        } else {
          this.message.error('移至分组失败!');
        }
      });
    }
  }
  // 批量归档
  batchArchivePulse() {
    let state = false;
    this.pulseCheckedId.forEach((item, index) => {
      if (this.checkTreeData(item)) {
        state = true;
      }
    });
    if (state) {
      this.confirmModal = this.modal.confirm({
        nzTitle: '归档的父级任务不能含有未选中的子任务，请检查。',
        nzWrapClassName: 'vertical-center-modal',
        nzOkText: null
      });
    } else {
      this.confirmModal = this.modal.confirm({
        nzTitle: '是否确认归档?',
        nzWrapClassName: 'vertical-center-modal',
        nzOnOk: () => {
          const param = {};
          param['pulseIds'] = this.pulseCheckedData.pulseIds;
          this.dataSubscription = this.taskService.doDeletePulse(param).subscribe((res: any) => {
            for (let i = 0; i < this.pulseCheckedData.pulseIds.length; i++) {
              this.boardPulseData = this.boardPulseData.filter(d => d.id !== this.pulseCheckedData.pulseIds[i]);
            }
            this.closeBatchMenu();
          });
        }
      });
    }
  }
  // 批量删除行
  batchDeletePulse() {
    let state = false;
    this.pulseCheckedId.forEach((item, index) => {
      if (this.checkBatchTreeData(item)) {
        state = true;
      }
    });
    if (state) {
      this.confirmModal = this.modal.confirm({
        nzTitle: '删除的父级任务不能含有未选中的子任务，请检查。',
        nzWrapClassName: 'vertical-center-modal',
        nzOkText: null
      });
    } else {
      this.confirmModal = this.modal.confirm({
        nzTitle: '是否确认删除?',
        nzWrapClassName: 'vertical-center-modal',
        nzOnOk: () => {
          this.dataSubscription = this.taskService.doDeletePulse(this.pulseCheckedData).subscribe((res: any) => {
            for (let i = 0; i < this.pulseCheckedData.pulseIds.length; i++) {
              this.boardPulseData = this.boardPulseData.filter(d => d.id !== this.pulseCheckedData.pulseIds[i]);
            }
            // this.getActiveGroup(this.activeGroup);
            this.nfUpdateTable.emit(true);
            this.closeBatchMenu();
          });
        }
      });
    }
  }
  // 批量检查父级是否包含未选中子级的数据
  checkBatchTreeData(id) {
    let s = false;
    for (const i in this.mapOfExpandedData) {
      if (this.mapOfExpandedData.hasOwnProperty(i)) {
        this.mapOfExpandedData[i].some(list => {
          if (id === list.id && list.children && list.children.length) {
            list.children.forEach(child => {
              if (this.pulseCheckedId.indexOf(child.id) < 0) {
                s =  true;
              }
            });
          }
        });
      }
    }
    return s;
  }
  // 单个检查父级是否包含子级数据
  checkTreeData(id) {
    let s = false;
    for (const i in this.mapOfExpandedData) {
      if (this.mapOfExpandedData.hasOwnProperty(i)) {
        this.mapOfExpandedData[i].some(list => {
          if (id === list.id && list.children && list.children.length) {
            s =  true;
          }
        });
      }
    }
    return s;
  }
  // hasClass
  hasClass(elem, className) {
    const reg = new RegExp('(^|\\s+)' + className + '($|\\s+)');
    return reg.test(elem.className);
  }
  // 点击当前列显示状态切换
  clickCurrentColumn(columnId, groupId) {
    this.clickCurrentColumnValue = columnId + groupId;
  }
  // 点击当前行显示状态切换
  clickCurrentPulse(pulseId) {
    this.clickCurrentPulseValue = pulseId;
  }
  // 删除行
  removePulse(pulseId) {
    const param = {};
    param['pulseIds'] = [pulseId];
    param['isDelete'] = true;
    const state = this.checkTreeData(pulseId);
    if (state) {
      this.confirmModal = this.modal.confirm({
        nzTitle: '当前任务下含有子任务，无法删除。',
        nzWrapClassName: 'vertical-center-modal',
        nzOkText: null
      });
    } else {
      this.dataSubscription = this.taskService.doDeletePulse(param).subscribe((res: any) => {
        this.boardPulseData = this.boardPulseData.filter(d => d.id !== pulseId);
        for (const i in this.mapOfExpandedData) {
          if (this.mapOfExpandedData.hasOwnProperty(i)) {
            this.mapOfExpandedData[i] = this.mapOfExpandedData[i].filter(d => d.id !== pulseId);
          }
        }
      });
    }
  }
  // 删除列
  removeColumn(boardId, columnId) {
    const param = {
      'destroy': 'true'
    };
    this.dataSubscription = this.taskService.doDeleteColumn(boardId, columnId, param).subscribe((res: any) => {
      this.boardColumnData = this.boardColumnData.filter(d => d.id !== columnId);
      // this.setProgressValue();
      // this.removeFilterColumn(columnId);
    });
  }
  // 归档行
  archivePulse(pulseId) {
    const param = {};
    param['pulseIds'] = [pulseId];
    const state = this.checkTreeData(pulseId);
    if (state) {
      this.confirmModal = this.modal.confirm({
        nzTitle: '当前任务下含有子任务，无法归档。',
        nzWrapClassName: 'vertical-center-modal',
        nzOkText: null
      });
    } else {
      this.dataSubscription = this.taskService.doDeletePulse(param).subscribe((res: any) => {
        this.boardPulseData = this.boardPulseData.filter(d => d.id !== pulseId);
        for (const i in this.mapOfExpandedData) {
          if (this.mapOfExpandedData.hasOwnProperty(i)) {
            this.mapOfExpandedData[i] = this.mapOfExpandedData[i].filter(d => d.id !== pulseId);
          }
        }
      });
    }
  }
  // 处理列权限
  handleColumnPermission(type, columnId, state) {
    this.boardColumnData.forEach((item, index) => {
      if (item.id === columnId) {
        this.boardColumnData[index].permissionType = state === 'false' ? null : type;
        this.boardColumnData[index].permittedUserIds = [];
      }
    });
  }
  // 列权限控制
  columnPermissionSet(type, columnId, state) {
    const param = {};
    param[type] = state;
    if (type === 'lock') {
      this.dataSubscription = this.taskService.setLockState(this.boardId, columnId, param).subscribe((res: any) => {
        this.handleColumnPermission(type, columnId, state);
      });
    } else if (type === 'hide') {
      this.dataSubscription = this.taskService.setHideState(this.boardId, columnId, param).subscribe((res: any) => {
        this.handleColumnPermission(type, columnId, state);
      });
    }
  }
  // 列加密状态切换
  columnEncryptChange(column) {
    let state = null;
    if (!column.encrypt) {
      state = 'true';
    }
    if (column.encrypt === 'true') {
      state = 'false';
    } else if (column.encrypt === 'false') {
      state = 'true';
    }
    this.handleColumnEncrypt(column.id, state);
  }
  // 列加密数据处理
  handleColumnEncrypt(columnId, state) {
    this.boardColumnData.forEach((item, index) => {
      if (item.id === columnId) {
        item.encrypt = state;
      }
    });
    const param = {
      'encrypt': state
    };
    this.dataSubscription = this.taskService.setColumnEncrypt(this.boardId, columnId, param).subscribe((res: any) => {
      this.message.create('success', '设置成功！');
    });
  }
  // 成员选择
  columnSelectMember(column) {
    this.isMemberVisible = true;
    this.currentColumnData = column;
  }
  handleMemberCancel() {
    this.isMemberVisible = false;
    this.currentColumnData = null;
  }
  removeFilterColumn(columnId) {
    const index = this.filterData.columns.findIndex(item => item.columnId === columnId);
    this.filterData.columns.splice(index, 1);
    this.filter();
  }
  filter() {
    const groupSet = new Set();
    const pulses = [];
    const groupIds = [];
    for (const group of this.filterData.selectedGroups) {
      groupIds.push(group.groupId);
    }
    if (this.boardData.boardData.pulses && this.boardData.boardData.pulses.length > 0) {
      for (const pulse of this.boardData.boardData.pulses) {
        if (groupIds.length > 0 && !groupIds.includes(pulse.groupId)) {
          continue;
        }
        let flag = true;
        if (this.filterData.columns.length > 0) {
          for (const filterColumn of this.filterData.columns) {
            const values = [];
            for (const item of filterColumn.selectedValue) {
              if (filterColumn.type === 'link') {
                values.push(item);
              } else {
                values.push(item.value);
              }
            }
            if (values.length > 0) {
              let cellValue = pulse.columnValues[filterColumn.columnId];
              switch (filterColumn.type) {
                case 'date-time':
                case 'date':
                  const v = cellValue && cellValue['date'] ? cellValue['date'] : '';
                  flag = values.includes(v);
                  break;
                case 'file':
                  if (cellValue && cellValue['files'] && cellValue['files'].length > 0) {
                    let fileFlag = false;
                    for (const file of cellValue['files']) {
                      fileFlag = fileFlag || values.includes(file.name);
                    }
                    flag = fileFlag;
                  } else {
                    flag = values.includes('');
                  }
                  break;
                case 'link':
                  flag = cellValue && (values.findIndex(item => item.value == cellValue['url'] && item.title === cellValue['name']) > -1);
                  break;
                case 'name':
                case 'text':
                  cellValue = cellValue || '';
                  flag = values.includes(cellValue);
                  break;
                case 'multiple-person':
                  if (cellValue && cellValue['personsAndTeams'] && cellValue['personsAndTeams'].length > 0) {
                    let personFlag = false;
                    for (const person of cellValue['personsAndTeams']) {
                      personFlag = personFlag || values.includes(person.id);
                    }
                    flag = personFlag;
                  } else {
                    flag = values.includes('');
                  }
                  break;
                case 'status':
                  flag = values.includes(cellValue['index']);
                  break;
                case 'dropdown':
                  if (cellValue && cellValue['ids'] && cellValue['ids'].length > 0) {
                    let dropFlag = false;
                    for (const id of cellValue['ids']) {
                      dropFlag = dropFlag || values.includes(id);
                    }
                    flag = dropFlag;
                  } else {
                    flag = values.includes('');
                  }
                  break;
                case 'select':
                  flag = values.includes(cellValue['option']);
                  break;
                case 'check':
                  for (const value of values) {
                    if (value === 'true') {
                      flag = value === cellValue;
                    } else {
                      flag = (cellValue === '\"true\"' || cellValue === 'false');
                    }
                    if (flag) {
                      break;
                    }
                  }
                  break;
                case 'multiple-level-person':
                  if (cellValue && cellValue['personsAndTeams'] && cellValue['personsAndTeams'].length > 0) {
                    let personFlag = false;
                    for (const person of cellValue['personsAndTeams']) {
                      personFlag = personFlag || values.includes(person.id);
                    }
                    flag = personFlag;
                  } else {
                    flag = values.includes('');
                  }
                  break;
                case 'taskProgress':
                  if (cellValue.value) {
                    flag = values.includes(cellValue.value['index']);
                  } else {
                    flag = false;
                  }
                  break;
                case 'taskType':
                  values.forEach(_v => {
                    if (_v === '自动' && pulse.taskDef && (pulse.taskDef.indicatorItemIdList || pulse.taskDef.auditItemIdList)) {
                      flag = true;
                    } else {
                      flag = false;
                    }
                    if (_v === '手动' && pulse.taskDef && !(pulse.taskDef.indicatorItemIdList || pulse.taskDef.auditItemIdList)) {
                      flag = true;
                    }
                  });
                  if (values.length === 2) {
                    flag = true;
                  }
                  break;
              }
              if (!flag) {
                break;
              }
            }
          }
        }
        if (flag) {
          groupSet.add(pulse.groupId);
          pulses.push(pulse);
          if (pulse.parentId) {
            this.boardPulseData.forEach(_item => {
              if (_item.id === pulse.parentId) {
                if (_item.children) {
                  _item.children = _item.children.filter(_d => _d.id === pulse.id);
                }
                pulses.push(_item);
                if (_item.parentId && _item.parentId === _item.id) {
                  pulses.push(_item);
                }
              }
            });
          }
          this.listOfMapData = this.listConvertTree(pulses);
          this.listOfMapData = this.duplicateRemoval(this.listOfMapData);
          this.pulseCheckedId = [];
          this.listOfMapData.forEach(item => {
            item.isPulseOpenSelection = false;
            this.mapOfExpandedData[item.id] = this.convertTreeToList(item);
          });
        }
      }
    }
    this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups.filter((item) => {
      return groupIds.length > 0 ? groupIds.includes(item.id) && groupSet.has(item.id) : true;
    }) : [];
    this.boardPulseData = pulses;
    localStorage.setItem(this.boardId, JSON.stringify(this.filterData));
  }
  filterChild() {

  }
  isExist(arr: Array<any>, obj, attr, attr2?): boolean {
    if (arr) {
      for (const item of arr) {
        if (item[attr] === obj[attr]) {
          if (attr2) {
            if (item[attr2] === obj[attr2]) {
              item.count++;
              return true;
            }
          } else {
            item.count++;
            return true;
          }
        }
      }
    }
    return false;
  }
  // 模糊搜索
  onMemberSearch(value: string): void {
    this.isLoading = true;
    this.pageIndex = 1;
    const param = {
      size: this.pageSize.toString(),
      page: this.pageIndex.toString(),
      searchKey: value
    };
    this.taskService.getBoardUer(this.boardData.id, param).subscribe((res: any) => {
      if (res) {
        this.memberList = res.users ? res.users.data : [];
        this.isLoading = false;
        this.pageIndex = res.users.page.number + 1;
      }
    });
  }
  handleBatchAddMemberCancel() {
    this.isBatchAddMemberVisible = false;
  }
  handleBatchAttachOk() {
    const changeValues = [];
    this.selectedTaskValue.forEach(taskId => {
      this.boardPulseData.forEach(item => {
        if (item.id === taskId) {
          if (item.columnValues[this.currentColumnId]) {
            if (item.columnValues[this.currentColumnId].personsAndTeams) {
              item.columnValues[this.currentColumnId].personsAndTeams.push(...this.selectedMemberValue);
              const obj = {};
              item.columnValues[this.currentColumnId].personsAndTeams = item.columnValues[this.currentColumnId].personsAndTeams.reduce((cur, next) => {
                obj[next.id] ? '' : obj[next.id] = true && cur.push(next);
                return cur;
              }, []);
            } else {
              item.columnValues[this.currentColumnId].personsAndTeams = this.selectedMemberValue;
            }
            changeValues.push({
              pulseIds: [taskId],
              columnId: this.currentColumnId,
              columnValue: item.columnValues[this.currentColumnId]
            });
          }
        }
      });
    });
    if (changeValues.length > 0) {
      this.batchUpdateBoardMember(this.boardId, changeValues);
    }
  }
  // 批量更新人员请求
  batchUpdateBoardMember(boardId, param) {
    this.taskService.batchAttachUser(boardId, param).subscribe(res => {
      if (res) {
        this.message.success('设置成功');
      } else {
        this.message.success('设置失败');
      }
      this.isBatchAddMemberVisible = false;
    });
  }
  // 下拉加载更多
  loadMore(): void {
    if (this.loadMoreData) {
      this.randomUserUrl = this.taskService.getBoardUser(this.boardId);
      const param = {
        size: this.pageSize.toString(),
        page: this.pageIndex.toString()
      };
      this.getBoardUserList = this.http
        .get(`${this.randomUserUrl}`, {params: param})
        .pipe(map((res: any) => res))
        .pipe(
          map((list: any) => {
            return list;
          })
        );
      this.isLoading = true;
      this.getBoardUserList.subscribe(data => {
        this.isLoading = false;
        if (data) {
          const newData = data.users && data.users.data ? data.users.data : [];
          this.memberList = [...this.memberList, ...newData];
          if (this.pageIndex >= data.users.page.totalPages) {
            this.loadMoreData = false;
            return;
          }
          this.pageIndex = data.users.page.number + 1;
        }
      });
    }
  }
  // 列排序
  sortColumn(column) {
    if (this.lastColumn && this.lastColumn !== column) {
      this.lastColumn.sort = null;
    }
    this.lastColumn = column;
    if (!column.sort) {
      column.sort = 'asc';
    } else if (column.sort === 'asc') {
      column.sort = 'desc';
    } else {
      column.sort = null;
    }
    const sort = column.sort;
    const columnId = column.id;
    if (sort) {
      const columnType = column.type;
      if (this.boardPulseData && this.boardPulseData.length > 0) {
        if (columnType === 'date') {
          this.boardPulseData.sort((a, b) => {
            const va = a.columnValues[columnId];
            const vb = b.columnValues[columnId];
            const date_a = va ? va.date : '';
            const date_b = vb ? vb.date : '';
            if (sort === 'asc') {
              return date_a > date_b ? 1 : (date_b === date_a ? 0 : -1);
            } else {
              return date_a > date_b ? -1 : (date_b === date_a ? 0 : 1);
            }
          });
        } else if (columnType === 'date-time') {
          this.boardPulseData.sort((a, b) => {
            const va = a.columnValues[columnId];
            const vb = b.columnValues[columnId];
            const time_a = va ? (va.date + va.time) : '';
            const time_b = vb ? (vb.date + vb.time) : '';
            if (sort === 'asc') {
              return time_a > time_b ? 1 : (time_b === time_a ? 0 : -1);
            } else {
              return time_a > time_b ? -1 : (time_b === time_a ? 0 : 1);
            }
          });
        } else if (columnType === 'status') {
          this.boardPulseData.sort((a, b) => {
            const va = a.columnValues[columnId];
            const vb = b.columnValues[columnId];
            const status_a = va ? va.index : -1;
            const status_b = vb ? vb.index : -1;
            if (sort === 'asc') {
              return status_a - status_b;
            } else {
              return status_b - status_a;
            }
          });
        }
      }
    } else { // 取消排序
      if (this.boardPulseData) {
        this.boardPulseData.sort((a, b) => {
          return a.createdAt - b.createdAt;
        });
      }
    }
  }
  // 获取行NAME编辑值
  getColumnName(pulseId, value, columnId) {
    if (value) {
      const param = {};
      param['name'] = value;
      if (this.originalValue !== value) {
        this.dataSubscription = this.taskService.doEditPulseName(pulseId, param).subscribe((res: any) => {
          this.editNameId = null;
          this.originalValue = res.name;
          this.updateFilterData(columnId);
        });
      }
    }
  }
  // 计算筛选数据
  calcFilterData() {
    this.filterData = {
      groups: [],
      selectedGroups: [],
      columns: []
    };
    if (this.boardData) {
      for (const group of this.boardGroupData) {
        this.filterData.groups.push({groupId: group.id, name: group.title, color: group.color});
      }
      for (const column of this.boardColumnData) {
        if (this.filterColumnExclude.includes(column.type)) continue;
        const columnValues = this.generateColumnValue(column);
        if (column.type !== 'createTime' && column.type !== 'handler' && column.type !== 'taskStatus' && column.type !== 'taskHandle' && column.type !== 'taskButton') {
          this.filterData.columns.push({
            columnId: column.id,
            type: column.type,
            name: column.title,
            maxHeight: '240px',
            valueMaxHeight: '',
            columnValues: columnValues,
            selectedValue: []
          });
        }
      }
      // 任务类型选项处理
      let _columnValues = [];
      let autoCount = 0;
      let manualCount = 0;
      this.boardPulseData.forEach(item => {
        if (item.taskDef && (item.taskDef.auditItemIdList || item.taskDef.indicatorItemIdList)) {
          autoCount += 1;
        }
      });
      manualCount = this.boardPulseData.length - autoCount;
      const autoValue = {
        title: '自动',
        value: '自动',
        count: autoCount
      };
      const manualValue = {
        title: '手动',
        value: '手动',
        count: manualCount
      };
      _columnValues = [autoValue, manualValue];
      for (const column of this.boardColumnData) {
        if (column.type === 'name') {
          const obj = {
            columnId: column.id,
            type: 'taskType',
            name: '任务类型',
            maxHeight: '240px',
            valueMaxHeight: '',
            columnValues: _columnValues,
            selectedValue: []
          };
          this.filterData.columns.push(obj);
        }
      }
    }
  }
  // 筛选交互
  updateFilterData(columnId) {
    let column: any = {};
    for (const item of this.boardColumnData) {
      if (item.id === columnId) {
        column = item;
        break;
      }
    }
    const columnValues = this.generateColumnValue(column);
    let filterColumn: any = {};
    for (const item of this.filterData.columns) {
      if (item.columnId === columnId) {
        filterColumn = item;
        break;
      }
    }
    if (filterColumn.columnValues) {
      filterColumn.columnValues.forEach(item => item.exist = false);
    }
    if (filterColumn.selectedValue) {
      filterColumn.selectedValue.forEach(item => item.exist = false);
    }
    if (column.type === 'link') {
      if (filterColumn.selectedValue) {
        filterColumn.selectedValue = filterColumn.selectedValue.filter(item => {
          return columnValues.findIndex(value => value.value === item.value && value.title === item.title) > -1;
        });
      }
      for (const item of columnValues) {
        item['exist'] = true;
        let flag = false;
        if (this.isExist(filterColumn.columnValues, item, 'value', 'title')) {
          flag = true;
          const index = filterColumn.columnValues.findIndex(value => value.value === item.value && value.title === item.title);
          filterColumn.columnValues[index] = item;
        }
        if (!flag) {
          if (this.isExist(filterColumn.selectedValue, item, 'value', 'title')) {
            const index = filterColumn.selectedValue.findIndex(value => value.value === item.value && value.title === item.title);
            filterColumn.selectedValue[index] = item;
          } else {
            if (filterColumn.columnValues) {
              filterColumn.columnValues.push(item);
            } else {
              filterColumn.columnValues = [];
              filterColumn.columnValues.push(item);
            }
          }
        }
      }
    } else {
      if (filterColumn.selectedValue) {
        filterColumn.selectedValue = filterColumn.selectedValue.filter(item => {
          return columnValues.findIndex(value => value.value === item.value) > -1;
        });
      }
      for (const item of columnValues) {
        item['exist'] = true;
        let flag = false;
        if (this.isExist(filterColumn.columnValues, item, 'value')) {
          flag = true;
          const index = filterColumn.columnValues.findIndex(value => value.value === item.value);
          filterColumn.columnValues[index] = item;
        }
        if (!flag) {
          if (this.isExist(filterColumn.selectedValue, item, 'value')) {
            const index = filterColumn.selectedValue.findIndex(value => value.value === item.value);
            filterColumn.selectedValue[index] = item;
          } else {
            if (filterColumn.columnValues) {
              filterColumn.columnValues.push(item);
            } else {
              filterColumn.columnValues = [];
              filterColumn.columnValues.push(item);
            }
          }
        }
      }
    }
    if (filterColumn.columnValues) {
      filterColumn.columnValues = filterColumn.columnValues.filter(item => item.exist);
    }
    if (filterColumn.selectedValue) {
      filterColumn.selectedValue = filterColumn.selectedValue.filter(item => item.exist);
    }
  }
  generateColumnValue(column) {
    const columnValues = [];
    for (const pulse of this.boardData.boardData.pulses) {
      let o = {title: '', value: '', count: 1};
      const pulseValues = pulse.columnValues;
      switch (column.type) {
        case 'date-time':
        case 'date':
          const cellValue = pulseValues[column.id] && pulseValues[column.id]['date'] ? pulseValues[column.id]['date'] : '';
          o = {
            title: cellValue,
            value: cellValue,
            count: 1
          };
          if (!this.isExist(columnValues, o, 'value')) {
            columnValues.push(o);
          }
          break;
        case 'file':
          if (pulseValues[column.id] && pulseValues[column.id]['files'] && pulseValues[column.id]['files'].length > 0) {
            for (const file of pulseValues[column.id]['files']) {
              o = {title: file.name, value: file.name, count: 1};
              if (!this.isExist(columnValues, o, 'value')) {
                columnValues.push(o);
              }
            }
          } else {
            if (!this.isExist(columnValues, o, 'value')) {
              columnValues.push(o);
            }
          }
          break;
        case 'link':
          o = {
            title: pulseValues[column.id] ? pulseValues[column.id]['name'] : '',
            value: pulseValues[column.id] ? pulseValues[column.id]['url'] : '',
            count: 1
          };
          if (!this.isExist(columnValues, o, 'value', 'title')) {
            columnValues.push(o);
          }
          break;
        case 'name':
        case 'text':
          const textValue = pulseValues[column.id] || '';
          o = {title: textValue, value: textValue, count: 1};
          if (!this.isExist(columnValues, o, 'value')) {
            columnValues.push(o);
          }
          break;
        case 'multiple-person':
          if (pulseValues[column.id] && pulseValues[column.id]['personsAndTeams'] && pulseValues[column.id]['personsAndTeams'].length > 0) {
            for (const person of pulseValues[column.id]['personsAndTeams']) {
              o = {title: person.name, value: person.id, count: 1};
              if (!this.isExist(columnValues, o, 'value')) {
                columnValues.push(o);
              }
            }
          } else {
            if (!this.isExist(columnValues, o, 'value')) {
              columnValues.push(o);
            }
          }
          break;
        case 'status':
          let label = '';
          let color = '';
          if (pulseValues[column.id]) {
            const labels = column.labels;
            for (const l of labels) {
              if (l.index === pulseValues[column.id]['index']) {
                label = l.label;
                color = l.color;
                break;
              }
            }
          }
          o = {
            title: label,
            value: pulseValues[column.id] ? pulseValues[column.id]['index'] : '',
            count: 1
          };
          o['color'] = color;
          if (!this.isExist(columnValues, o, 'value')) {
            columnValues.push(o);
          }
          break;
        case 'dropdown':
          if (pulseValues[column.id] && pulseValues[column.id]['ids'] && pulseValues[column.id]['ids'].length > 0) {
            if (column.settings && column.settings.labels) {
              for (const id of pulseValues[column.id]['ids']) {
                for (const _label of column.settings.labels) {
                  if (id === _label.id) {
                    o = {title: _label.name, value: id, count: 1};
                    if (!this.isExist(columnValues, o, 'value')) {
                      columnValues.push(o);
                    }
                    break;
                  }
                }
              }
            }
          } else {
            if (!this.isExist(columnValues, o, 'value')) {
              columnValues.push(o);
            }
          }
          break;
        case 'select':
          if (pulseValues[column.id] && pulseValues[column.id]['option'] && column.config && column.config.option) {
            for (const option of column.config.option) {
              if (option.id === pulseValues[column.id]['option']) {
                o = {title: option.title, value: option.id, count: 1};
                if (!this.isExist(columnValues, o, 'value')) {
                  columnValues.push(o);
                }
                break;
              }
            }
          } else {
            if (!this.isExist(columnValues, o, 'value')) {
              columnValues.push(o);
            }
          }
          break;
        case 'check':
          if (pulseValues[column.id] === 'true') {
            o.title = '✔';
            o.value = 'true';
          }
          if (!this.isExist(columnValues, o, 'value')) {
            columnValues.push(o);
          }
          break;
        case 'multiple-level-person':
          if (pulseValues[column.id] && pulseValues[column.id]['personsAndTeams'] && pulseValues[column.id]['personsAndTeams'].length > 0) {
            for (const person of pulseValues[column.id]['personsAndTeams']) {
              o = {title: person.name, value: person.id, count: 1};
              if (!this.isExist(columnValues, o, 'value')) {
                columnValues.push(o);
              }
            }
          } else {
            if (!this.isExist(columnValues, o, 'value')) {
              columnValues.push(o);
            }
          }
          break;
        case 'taskProgress':
          if (pulseValues[column.id] && pulseValues[column.id].value) {
            o = {title: pulseValues[column.id].value.label, value: pulseValues[column.id].value.index, count: 1};
          }
          if (!this.isExist(columnValues, o, 'value')) {
            columnValues.push(o);
          }
          break;
      }
    }
    return columnValues;
  }
  // 打开会话抽屉
  openDialog(boardId, column, pulse) {
    this.isDialogVisible = true;
    this.conversationBaseData = {
      'boardId': boardId,
      'column': column,
      'pulse': pulse,
      'currentUser': this.boardData.boardData.currentUser,
      'permissionDefinition': this.boardData.permissionDefinition
    };
  }
  closeDialog() {
    this.isDialogVisible = false;
  }
  // 获取文本单元格编辑值
  getColumnText(pulse, column, value) {
    const param = {};
    param['pulseIds'] = [pulse.id];
    param['columnId'] = column.id;
    param['columnValue'] = value;
    this.dataSubscription = this.taskService.doEditPulse(this.boardId, param).subscribe((res: any) => {
      this.editNameId = null;
      this.updateFilterData(column.id);
    });
  }
  // 获取行日期组件编辑的值
  getColumnDate(pulseId, columnId, value) {
    const param = {};
    param['pulseIds'] = [pulseId];
    param['columnId'] = columnId;
    param['columnValue'] = {
      'date': value ? this.datePipe.transform(value, 'yyyy-MM-dd') : ''
    };
    this.dataSubscription = this.taskService.doEditPulse(this.boardId, param).subscribe((res: any) => {
      this.updateFilterData(columnId);
    });
  }
  // 批量设置成员
  batchSettingMember(columnId) {
    this.currentColumnId = columnId;
    this.isBatchAddMemberVisible = true;
    this.selectedMemberValue = [];
    this.selectedTaskValue = [];
    this.onMemberSearch('');
    if (this.currentUser) {
      this.selectedMemberValue = [...this.selectedMemberValue, this.currentUser];
    }
  }
  // 按钮组件-按钮配置pop框
  openButtonConfig(pulseId, column) {
    this.clickCurrentPulseValue = pulseId;
    this.buttonConfigStatus = true;
    // 设置无法删除标识
    const userIds = this.getButtonUserIds(column);
    if (column.config.original && column.config.original.length > 0) {
      column.config.original.forEach((item, index) => {
        item.notRemove = false;
        for (let i = 0; i < userIds.length; i++) {
          if (item.id === userIds[i]) {
            item.notRemove = true;
          }
        }
      });
    }
  }
  // 按钮组件-删除
  removeButtonConfig(itemId, column) {
    column.config.original = column.config.original.filter(item => item.id !== itemId);
  }
  // 按钮组件-编辑
  editButtonConfig(item) {
    this.buttonConfigEditeData = item;
    this.buttonConfigStatus = !this.buttonConfigStatus;
    this.buttonConfigEditStatus = true;
    this.buttonConfigTitle = item.title;
    this.buttonConfigDisabled = item.usable;
    this.buttonConfigUrl = item.url;
  }
  // 按钮配置新增/编辑事件
  buttonConfigAdd() {
    this.buttonConfigTitle = null;
    this.buttonConfigDisabled = true;
    this.buttonConfigUrl = null;
    this.buttonConfigStatus = !this.buttonConfigStatus;
    this.buttonConfigEditStatus = false;
  }
  buttonConfigChange(event) {
    this.buttonConfigDisabled = event;
  }
  // 按钮配置提交
  buttonConfigSubmit(type, column) {
    if (!this.buttonConfigTitle) {
      this.message.create('error', '请输入按钮名称');
    } else {
      if (type === 'add') {
        const maxId = this.getMaxId(column.config.original) + 1;
        const addObj = {
          'id': maxId,
          'title': this.buttonConfigTitle,
          'type': 'primary',
          'usable': this.buttonConfigDisabled,
          'url': this.buttonConfigUrl,
          'isExternalUrl': this.isExternalUrl
        };
        column.config.original = [
          ...column.config.original,
          addObj
        ];
      } else if (type === 'edit') {
        column.config.original.forEach((item, index) => {
          if (item.id === this.buttonConfigEditeData.id) {
            item.title = this.buttonConfigTitle;
            item.usable = this.buttonConfigDisabled;
            item.url = this.buttonConfigUrl;
            item.isExternalUrl = this.isExternalUrl;
          }
        });
      }
      const param = {
        'config': column.config
      };
      this.dataSubscription = this.taskService.doEditColumnHeader(this.boardId, column.id, param).subscribe((res: any) => {});
      this.buttonConfigStatus = !this.buttonConfigStatus;
    }
  }
  // 获取按钮ID
  getMaxId(data) {
    const ids = [];
    if (data && data.length > 0) {
      data.forEach((item, index) => {
        ids.push(item.id);
      });
      return ids.reduce((a, b) => {
        return b > a ? b : a;
      });
    } else {
      return 0;
    }
  }
  // 按钮组件-获取所有按钮已用ID
  getButtonUserIds(column) {
    let useIds = [];
    this.boardPulseData.forEach((pulses, index) => {
      for (const item in pulses.columnValues) {
        if (pulses.columnValues.hasOwnProperty(item)) {
          if (pulses.columnValues[column.id].original) {
            useIds.push(pulses.columnValues[column.id].original);
          }
        }
      }
    });
    useIds = Array.from(new Set(useIds));
    return useIds;
  }
  // 按钮组件-配置关联
  buttonRelationChange(event, column) {
    column.config.relation = event;
    const param = {
      'config': column.config
    };
    this.dataSubscription = this.taskService.doEditColumnHeader(this.boardId, column.id, param).subscribe((res: any) => {});
  }
  buttonSelectChange(event, pulseId, column) {
    const param = {};
    param['pulseIds'] = [pulseId];
    param['columnId'] = column.id;
    param['columnValue'] = {
      'original': event
    };
    this.dataSubscription = this.taskService.doEditPulse(this.boardId, param).subscribe((res: any) => {});
  }
  // 按钮组件-自定义按钮点击事件
  buttonCustomClick(column, pulse) {
    let isExternalUrl = false;
    let url = '';
    column.config.original.forEach((item, index) => {
      if (item.id.toString() === pulse.columnValues[column.id].original.toString()) {
        url = item.url;
        isExternalUrl = item.isExternalUrl;
      }
    });
    const param = {
      'pulseId': pulse.id,
      'columnId': column.id
    };
    this.clickButtonLoading = true;
    this.dataSubscription = this.taskService.buttonClickEvent(url, param, isExternalUrl).subscribe((res: any) => {
      this.nfUpdateTable.emit(true);
      this.clickButtonLoading = false;
    }, (err) => {
      this.clickButtonLoading = false;
    });
  }
  // 按钮组件-关联按钮点击事件
  buttonRelationClick(url, pulseId) {
    // todo 后台交互
    console.log(url + pulseId)
  }
  // 投票组件交互
  getVoteData(pulse, columnId, value) {
    const param = {};
    param['pulseIds'] = [pulse.id];
    param['columnId'] = columnId;
    param['columnValue'] = {
      voters: value
    };
    this.dataSubscription = this.taskService.doEditPulse(this.boardId, param).subscribe((res: any) => {});
  }
  // 添加任务
  openAddTaskDialog() {
    this.isAddTaskVisible = true;
    this.taskRuleRelevance = null;
    this.setOfCheckedId.clear();
    this.selectProductList = [];
    this.addTaskForm.reset();
    this.addTaskForm.get('groupId').patchValue(this.activeGroup.id);
    this.groupChange(this.activeGroup.id);
    this.createWayType = null;
    this.taskRulesValue = null;
    this.getManualTask();
  }
  getCreateWayType(event) {
    this.createWayType = event;
  }
  handleAddTaskCancel() {
    this.isAddTaskVisible = false;
  }
  handleAddTaskOk() {
    if (this.createWayType === 'taskPool') {
      if (this.taskRulesValue) {
        // 选择任务池创建任务
        const codeList = [];
        this.setOfCheckedId.forEach(item => {
          codeList.push(item);
        });
        const param = {
          boardId: this.boardId,
          groupId: this.activeGroup.id,
          taskDefId: this.taskRulesValue,
          productCodeList: codeList
        };
        this.taskService.addManualTask(param).subscribe(res => {
          this.isAddTaskVisible = false;
          this.message.success('添加成功，任务生成中!');
        }, () => {
          this.isAddTaskVisible = false;
        });
      } else {
        this.message.create('warning', '请选择任务规则！');
      }
    } else if (this.createWayType === 'manual') {
      for (const i in this.addTaskForm.controls) {
        if (this.addTaskForm.controls.hasOwnProperty(i)) {
          this.addTaskForm.controls[i].markAsDirty();
          this.addTaskForm.controls[i].updateValueAndValidity();
        }
      }
      if (!this.addTaskForm.invalid) {
        this.addPulse(this.boardId, this.addTaskForm.get('groupId').value, this.addTaskForm.get('name').value);
      }
    }
  }
  backToChoseCreateType() {
    this.createWayType = null;
  }
  groupChange(event) {
    const groupId = event;
    this.parentTaskData = [];
    const group = this.boardGroupData.filter(d => d.id === groupId);
    if (group[0].pulses && group[0].pulses.length) {
      const treePulse = this.listConvertTree(group[0].pulses);
      this.parentTaskData = this.handleTreeData(treePulse);
    }
  }
  addPulse(boardId, groupId, value) {
    const o = {};
    this.boardColumnData.forEach((item, index) => {
      if (item.type === 'multiple-person') {
        o[item.id] = {'personsAndTeams' : []};
      } else if (item.type === 'status') {
        o[item.id] = {
          'index': 0
        };
      } else if (item.type === 'date') {
        o[item.id] = {};
      } else if (item.type === 'date-time') {
        o[item.id] = {};
      } else if (item.type === 'time-interval') {
        o[item.id] = {};
      } else if (item.type === 'name') {
        o[item.id] = value;
      } else if (item.type === 'dropdown') {
        o[item.id] = {};
      } else if (item.type === 'file') {
        o[item.id] = {
          config: {
            watermark: true,
            watermarkContent: ''
          },
          files: []
        };
      } else if (item.type === 'link') {
        o[item.id] = {
          name: '',
          url: '',
          params: [],
          skipMode: '1'
        };
      } else {
        o[item.id] = '';
      }
    });
    o['name'] = value;
    const param = {};
    const parentId = this.addTaskForm.get('parentId').value ? this.addTaskForm.get('parentId').value : null;
    const taskDate = this.addTaskForm.get('taskDate').value;
    param['boardId'] = boardId;
    param['groupId'] = groupId;
    param['parentId'] = parentId;
    param['name'] = value;
    param['columnValues'] = {
      'name': value
    };
    if (taskDate) {
      param['taskDateStart'] = this.datePipe.transform(taskDate[0], 'yyyy-MM-dd');
      param['taskDateEnd'] = this.datePipe.transform(taskDate[1], 'yyyy-MM-dd');
    }
    this.dataSubscription = this.taskService.doAddPulse(param).subscribe((res: any) => {
      if (res) {
        this.boardPulseData = [
          ...this.boardPulseData,
          {
            id: res.id,
            groupId: res.groupId,
            name: value,
            parentId: parentId,
            columnValues: o,
            columnPermissions: res.columnPermissions,
            updatesCount: 0
          }
        ];
        this.isAddTaskVisible = false;
        this.getActiveGroup(this.activeGroup);
      }
    });
  }
  // 获取任务池列表
  getManualTask() {
    this.dataSubscription = this.taskService.getManualTaskData(this.boardId).subscribe((res: any) => {
      const _data = res && res['_embedded'] && res['_embedded'].vos ? res['_embedded'].vos : [];
      _data.forEach(item => {
        item['title'] = item.name;
      });
      this.taskRulesOption = this.listConvertTree(_data);
      this.taskRulesOption = this.handleTreeData(this.taskRulesOption);
    });
  }
  // 列拖动
  dropColumn(event: CdkDragDrop<string[]>) {
    const pos = [];
    this.boardColumnData.forEach(column => pos.push(column.position));
    moveItemInArray(this.boardColumnData, event.previousIndex + 1, event.currentIndex + 1);
    const params = [];
    for (let i = 0; i < this.boardColumnData.length; i++) {
      params.push({
        id: this.boardColumnData[i].id,
        title: this.boardColumnData[i].title,
        position: i
      });
    }
    this.taskService.changeColumnPos(params).subscribe(res => {
      if (!res) {
        this.message.error('保存列位置异常！');
      }
    });
  }
  // 选中组
  selectGroup(group) {
    const groupPulses = this.boardPulseData.filter(item => group.id == item.groupId);
    for (const pulse of groupPulses) {
      if (!this.pulseCheckedId.includes(pulse.id)) {
        this.pulseCheckedId.push(pulse.id);
        pulse.isDelete = true;
      }
    }
    this.pulseCheckedData = {
      isDelete: true,
      pulseIds: this.pulseCheckedId
    };
    group.menuPopVisible = false;
  }
  getTimeInterval(pulseId, columnId, event) {
    const param = {};
    param['pulseIds'] = [pulseId];
    param['columnId'] = columnId;
    if (event && event.length == 2) {
      let format = 'yyyy-MM-dd HH:mm';
      param['columnValue'] = {
        'date': [this.datePipe.transform(event[0], format), this.datePipe.transform(event[1], format)]
      };
    } else {
      param['columnValue'] = {
        'date': []
      };
    }
    this.dataSubscription = this.taskService.doEditPulse(this.boardId, param).subscribe((res: any) => {});
  }
  getColumnDateTime(pulseId, columnId, event) {
    const param = {};
    param['pulseIds'] = [pulseId];
    param['columnId'] = columnId;
    param['columnValue'] = event;
    this.dataSubscription = this.taskService.doEditPulse(this.boardId, param).subscribe((res: any) => {
      this.updateFilterData(columnId);
    });
  }
  myTaskChange() {
    // console.log(this.activeGroup)
    // this.listOfMapData = [];
    // this.mapOfExpandedData = {};
  }
  // 筛选
  useLastCondition() {
    const condition = localStorage.getItem(this.boardId);
    if (condition) {
      this.filterData = JSON.parse(condition);
      this.filter();
    } else {
      this.message.info('未查询到上次筛选配置');
    }
  }
  clearFilterCondition() {
    this.boardGroupData = this.boardData.boardData.groups || [];
    this.boardPulseData = this.boardData.boardData.pulses || [];
    this.filterData.selectedGroups.forEach(item => {
      this.filterData.groups.push(item);
    });
    this.filterData.selectedGroups = [];
    this.filterData.columns.forEach(column => {
      column.selectedValue.forEach(value => {
        column.columnValues.push(value);
      });
      column.selectedValue = [];
    });
  }
  chooseGroup(group, i) {
    this.filterData.selectedGroups.push(group);
    this.filterData.groups.splice(i, 1);
    this.filter();
  }

  removeGroupFilter(group, i) {
    this.filterData.groups.push(group);
    this.filterData.selectedGroups.splice(i, 1);
    this.filter();
  }

  chooseValue(column, value, index) {
    column.columnValues.splice(index, 1);
    column.selectedValue.push(value);
    this.calcHeight(column);
    this.filter();
  }
  removeValue(column, value, index) {
    column.columnValues.push(value);
    column.selectedValue.splice(index, 1);
    this.calcHeight(column);
    this.filter();
  }
  calcHeight(column) {
    if (column.selectedValue.length === 0) {
      column.maxHeight = '240px';
    } else if (column.selectedValue.length === 1) {
      column.maxHeight = '184px';
    } else if (column.selectedValue.length === 2) {
      column.maxHeight = '148px';
    } else if (column.selectedValue.length === 3) {
      column.maxHeight = '112px';
    } else if (column.selectedValue.length > 3 && column.columnValues.length === 3) {
      column.valueMaxHeight = '112px';
    } else if (column.selectedValue.length > 3 && column.columnValues.length === 2) {
      column.valueMaxHeight = '148px';
    } else if (column.selectedValue.length > 3 && column.columnValues.length === 1) {
      column.valueMaxHeight = '184px';
    } else if (column.selectedValue.length > 3 && column.columnValues.length === 0) {
      column.valueMaxHeight = '240px';
    } else {
      column.maxHeight = '110px';
      column.valueMaxHeight = '110px';
    }
  }
  // 任务完成情况设置
  openTaskProgressDialog(columnId) {
    this.currentColumnId = columnId;
    this.boardColumnData.forEach(item => {
      if (item.id === columnId && item.labels) {
        this.statusOptionData = item.labels;
      }
    });
    this.isAddStatusListVisible = true;
  }
  handleStatusListOk() {
    this.submitEditStatus(this.currentColumnId, this.boardId);
    this.isAddStatusListVisible = false;
  }
  // 标签组件提交编辑
  submitEditStatus(columnId, boardId) {
    const param = {
      'labels': this.statusOptionData
    };
    this.taskService.doAddStatusLabel(boardId, columnId, param).subscribe((res: any) => {
      this.boardColumnData.forEach((item, index) => {
        if (item.id === columnId) {
          item.labels = this.statusOptionData;
        }
      });
    });
  }
  handleAddStatusListCancel() {
    this.isAddStatusListVisible = false;
  }
  quickAddStatus(value, text, color) {
    const obj = {
      index: value,
      label: text,
      color: color
    };
    if (text === '强制完成') {
      obj['event'] = 'forceCompletion';
    }
    if (text === '延期') {
      obj['event'] = 'delay';
    }
    if (text === '强制完成') {
      obj['event'] = 'forceCompletion';
      obj['symbol'] = 'complete';
    }
    if (text === '异常') {
      obj['symbol'] = 'abnormal';
    }
    if (text === '已完成') {
      obj['symbol'] = 'complete';
    }
    const params = {
      name: obj.label,
      value: obj.index,
      mark: obj['symbol'],
      boardId: this.boardId
    };
    this.taskService.postBoardTaskStatus(params).subscribe((res: any) => {
      this.statusOptionData = [obj, ...this.statusOptionData];
    });
  }
  openStatusItemDialog() {
    this.isAddStatusItemVisible = true;
    this.isEditStatusItem = false;
    this.addItemForm.reset();
    this.currentPanelColor = '#fff';
  }
  openStatusOption(data) {
    this.isAddStatusItemVisible = true;
    this.isEditStatusItem = true;
    this.currentStatusItem = data;
    if (data.color) {
      this.currentPanelColor = data.color;
    }
    for (const i in data) {
      if (data.hasOwnProperty(i)) {
        if (this.addItemForm.get(i)) {
          this.addItemForm.get(i).patchValue(data[i]);
        }
      }
    }
  }
  deleteStatusOption(i, value) {
    this.taskService.deleteBoardTaskStatus(value, this.boardId).subscribe(res => {
      this.statusOptionData.splice(i, 1);
    });
  }
  handleAddStatusItemCancel() {
    this.isAddStatusItemVisible = false;
  }
  submitItemForm() {
    for (const i in this.addItemForm.controls) {
      this.addItemForm.controls[i].markAsDirty();
      this.addItemForm.controls[i].updateValueAndValidity();
    }
    if (!this.addItemForm.invalid) {
      const item = this.addItemForm.getRawValue();
      if (this.isEditStatusItem) {
        // 编辑状态
        const params = {
          name: this.addItemForm.get('label').value,
          value: this.addItemForm.get('index').value,
          mark: this.addItemForm.get('symbol').value,
          boardId: this.boardId
        };
        this.taskService.patchBoardTaskStatus(params).subscribe((res: any) => {
          this.statusOptionData.forEach((_item, i) => {
            if (_item.index === this.currentStatusItem.index) {
              this.statusOptionData.splice(i, 1);
            }
          });
          this.statusOptionData = [item, ...this.statusOptionData];
          this.isAddStatusItemVisible = false;
        });
      } else {
        // 新增状态
        const indexArr = [];
        this.statusOptionData.forEach(i => {
          indexArr.push(i.index);
        });
        if (indexArr.includes(item.index)) {
          this.message.error('状态值: ' + item.index + '，已经存在，请重新输入！');
          return;
        }
        const params = {
          name: this.addItemForm.get('label').value,
          value: this.addItemForm.get('index').value,
          mark: this.addItemForm.get('symbol').value,
          boardId: this.boardId
        };
        this.taskService.postBoardTaskStatus(params).subscribe((res: any) => {
          this.statusOptionData = [item, ...this.statusOptionData];
          this.isAddStatusItemVisible = false;
        });
      }
    }
  }
  changeColor(color) {
    this.currentPanelColor = color;
    this.addItemForm.get('color').patchValue(this.currentPanelColor);
  }
  handleStatusItemOk() {
    this.submitItemForm();
  }
  drop(event: CdkDragDrop<string[]>): void {
    moveItemInArray(this.statusOptionData, event.previousIndex, event.currentIndex);
  }
  genID(length) {
    return Number(Math.random().toString().substr(3, length) + Date.now()).toString(36);
  }
  //  任务规则管理
  openTaskRulesDialog() {
    this.isTaskRulesVisible = true;
  }
  taskRulesClose() {
    this.isTaskRulesVisible = false;
  }
  taskStatisticsChange() {
    this.taskStatisticsVisible = !this.taskStatisticsVisible;
  }
  // 获取面板统计
  boardStatisticData() {
    this.taskService.boardStatistic(this.boardId).subscribe((res: any) => {
      this.boardStatisticList = res ? res : [];
      this.boardStatisticList.forEach(item => {
        item.progress = ((item.finishedCount / item.totalCount) * 100).toFixed(0);
      });
    });
  }
  handleTreeData(data) {
    data.forEach(item => {
      item.title = item.name;
      item.key = item.id;
      if (item.children && item.children.length) {
        this.handleTreeData(item.children);
        item.isLeaf = false;
      } else {
        item.isLeaf = true;
      }
    });
    return data;
  }
  taskRulesChange(event) {
    if (event.node && event.node.origin) {
      this.taskRuleRelevance = this.handelTaskRuleTreeRelevanceType(event.node.origin);
    }
  }
  handelTaskRuleTreeRelevanceType(data) {
    let val: string;
    if (data.relevance) {
      val = data.relevance;
    } else if (data.children && data.children.length > 0) {
      data.children.forEach(item => {
        if (item.relevance) {
          val = item.relevance;
        } else {
          this.handelTaskRuleTreeRelevanceType(item);
        }
      });
    }
    return val;
  }
  // 获取产品列表
  getProductOption() {
    const getProductList = (name: string): Observable<any> =>
      this.http
        .get(`${this.productUrl}`)
        .pipe(
          catchError(() => of({ results: [] })),
          map((res: any) => res)
        )
        .pipe(map((list: any) => list.map((item: any) => `${item.name} ${name}`)));
    const optionList$: Observable<string[]> = this.searchChange$
      .asObservable()
      .pipe(debounceTime(500))
      .pipe(switchMap(getProductList));
    optionList$.subscribe(data => {
      this.productOption = data;
      this.isProductLoading = false;
    });
  }
  onProductSearch(value: string): void {
    this.isProductLoading = true;
    this.searchChange$.next(value);
  }
  // loadMoreProduct(): void {
  //   if (this.isLoadMoreData) {
  //     const param = {
  //       rows: this.productPageSize.toString(),
  //       page: this.productPageIndex.toString()
  //     };
  //     this.getProductList = this.http
  //       .get(`${this.productUrl}`, {params: param})
  //       .pipe(map((res: any) => res))
  //       .pipe(
  //         map((list: any) => {
  //           return list;
  //         })
  //       );
  //     this.isProductLoading = true;
  //     this.getProductList.subscribe(data => {
  //       this.isProductLoading = false;
  //       if (data) {
  //         const newData = data && data._embedded ? data._embedded.vos : [];
  //         this.productOption = [...this.productOption, ...newData];
  //         this.productPageIndex = data.page.number + 1;
  //         if (this.productPageIndex === data.page.totalPages) {
  //           this.loadMoreData = false;
  //           return;
  //         }
  //       }
  //     });
  //   }
  // }
  // 获取产品列表
  getProductListData(param) {
    this.isProductLoading = true;
    this.taskService.getProdProducts(param).subscribe((res: any) => {
      this.isProductLoading = false;
      if (res) {
        this.productListOfData = res._embedded ? res._embedded.vos : [];
        this.productPageTotal = res.page.totalElements;
      }
    }, () => {
      this.isProductLoading = false;
    });
  }
  productIndexChange(event) {
    this.productPageIndex = event;
    const param = {
      rows: this.productPageSize.toString(),
      page: this.productPageIndex.toString()
    };
    this.getProductListData(param);
  }
  productSizeChange(event) {
    this.productPageSize = event;
    const param = {
      rows: this.productPageSize.toString(),
      page: this.productPageIndex.toString()
    };
    this.getProductListData(param);
  }
  openProductDialog() {
    const param = {
      rows: this.productPageSize.toString(),
      page: this.productPageIndex.toString()
    };
    this.getProductListData(param);
    this.isProductVisible = true;
  }
  handleSelectProductClose(i, code) {
    this.selectProductList.splice(i, 1);
    this.setOfCheckedId.delete(code);
  }
  handleProductOk() {
    this.isProductVisible = false;
  }
  handleProductCancel() {
    this.isProductVisible = false;
  }
  updateCheckedSet(code: number, name: string, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(code);
      const obj = {
        code: code,
        name: name
      };
      this.selectProductList.push(obj);
    } else {
      this.setOfCheckedId.delete(code);
      this.selectProductList = this.selectProductList.filter(d => d.code !== code);
    }
  }

  onItemChecked(code: number, name: string, checked: boolean): void {
    this.updateCheckedSet(code, name, checked);
    this.refreshCheckedStatus();
  }

  onAllChecked(value: boolean): void {
    this.selectProductList = [];
    this.listOfCurrentPageData.forEach(item => this.updateCheckedSet(item.code, item.name, value));
    this.refreshCheckedStatus();
  }

  onCurrentPageDataChange($event): void {
    this.listOfCurrentPageData = $event;
    this.refreshCheckedStatus();
  }

  refreshCheckedStatus(): void {
    this.checked = this.listOfCurrentPageData.every(item => this.setOfCheckedId.has(item.id));
    this.indeterminate = this.listOfCurrentPageData.some(item => this.setOfCheckedId.has(item.id)) && !this.checked;
  }
  searchProduct() {
    const param = {
      rows: this.productPageSize.toString(),
      page: this.productPageIndex.toString(),
      nameFuzzy: this.searchProductValue
    };
    this.getProductListData(param);
  }
  // 修改组名弹窗
  editGroupNameDialog(name, boardId, groupId, groupColor) {
    this.isEditGroupNameVisible = true;
    this.currentEditGroupName = name;
    this.currentEditBoardId = boardId;
    this.currentEditGroupId = groupId;
    this.currentEditGroupColor = groupColor;
  }
  handleEditGroupNameOk() {
    if (this.currentEditGroupName) {
      const param = {
        title: this.currentEditGroupName,
        color: this.currentEditGroupColor
      };
      this.dataSubscription = this.dataSubscription = this.taskService.doEditGroupTitle(this.currentEditBoardId, this.currentEditGroupId, param).subscribe((res: any) => {
        this.boardGroupData.forEach(item => {
          if (item.id === this.currentEditGroupId) {
            item.title = this.currentEditGroupName;
          }
        });
        this.isEditGroupNameVisible = false;
        this.message.success('编辑成功！');
      });
    } else {
      this.message.warning('请输入组名称！');
    }
  }
  handleEditGroupNameCancel() {
    this.isEditGroupNameVisible = false;
  }
  // 虚拟滚动
  trackByIndex(_: number, data): number {
    return data.index;
  }
  /****
   *
   * 日志操作组件交互
   *
   * ****/
  // 前置任务处理
  preTaskHandle(data: Array<any>, preTaskId) {
    let flag = true;
    let taskTitle: string;
    let currentColumn: any;
    this.boardColumnData.forEach(item => {
      if (item.type === 'taskProgress') {
        currentColumn = item;
      }
    });
    data.forEach(item => {
      preTaskId.forEach(_per => {
        if (item.taskDef && item.taskDef.id) {
          if (_per === item.taskDef.id) {
            if (!(item.columnValues[currentColumn.id] && (item.columnValues[currentColumn.id].progress === 100) || item.columnValues[currentColumn.id].symbol === 'complete' || (item.columnValues[currentColumn.id].value && item.columnValues[currentColumn.id].value.symbol === 'complete'))) {
              flag = false;
              taskTitle = item.name;
            }
          }
        }
      });
    });
    const backVal = {
      title: taskTitle,
      status: flag
    };
    return backVal;
  }
  // 刷新稽核
  refreshAudit(event, pulse, column, type) {
    // 前置任务处理
    const preTaskId = pulse.preTaskDefId ? pulse.preTaskDefId.split(',') : [];
    if (pulse.taskDef && pulse.taskDef.preTaskDefId) {
      const backVal = this.preTaskHandle(this.boardPulseData, preTaskId);
      if (!backVal.status) {
        this.message.create('warning', '请先完成前置任务：' + backVal.title);
        return false;
      }
    }
    this.taskDataDate = localStorage.getItem('taskDataDate');
    if (event) {
      event.stopPropagation();
    }
    if (pulse && type === 'all') {
      this.currentPulseData = pulse;
    }
    if (column && type === 'all') {
      this.currentColumnData = column;
    }
    if (this.currentPulseData && this.currentColumnData && this.currentPulseData.columnValues[this.currentColumnData.id]) {
      this.currentPulseData.columnValues[this.currentColumnData.id] = {
        scanStatus : null
      };
    }
    let idList: any;
    const param = {
      dataDate: this.taskDataDate,
      reloadData: '1'
    };
    if (type === 'all') {
      if (this.currentPulseData.taskDef.auditItemIdList) {
        this.auditItemIdList = this.currentPulseData.taskDef.auditItemIdList;
        idList = this.auditItemIdList.join(',');
        param['itemIdList'] = this.auditItemIdList;
      }
    }
    if (pulse && type === 'single') {
      param['itemIdList'] = [pulse];
      idList = pulse;
    }
    const today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    if (today <= this.taskDataDate) {
      // 当天取稽核后台日期
      const param = {
        idList: idList
      };
      this.taskService.getRefreshTodayAuditDate(param).subscribe((res: any) => {
        if (res) {
          const paramArr = [];
          for (const i in res) {
            if (res.hasOwnProperty(i) && res[i]) {
              this.refreshTodayAudit(i, res[i], type);
              const _param = {
                itemIdList: [i],
                dataDate: res[i],
                reloadData: '1'
              };
              paramArr.push(_param);
            }
          }
          this.postBoardPulseScanLogData(this.taskDataDate, this.currentPulseData.id, {auditItemList: paramArr});
        }
      }, () => {
        clearInterval(this.scanAuditTimer);
        if (pulse.columnValues[column.id]) {
          pulse.columnValues[column.id]['scanAuditStatus'] = false;
        }
      });
    } else {
      // 查询历史稽核日期
      if (type === 'all') {
        this.taskService.getBoardPulseScanLog(this.currentPulseData.id, this.taskDataDate).subscribe((res: any) => {
          if (res && res.scanParam) {
            const scanParam = JSON.parse(res.scanParam);
            const auditItemList = scanParam.auditItemList;
            if (auditItemList && auditItemList.length) {
              auditItemList.forEach(_list => {
                const _param = _list;
                if (this.currentPulseData.taskPulseInfo && this.currentPulseData.taskPulseInfo.fundCode) {
                  _param['fundCode'] = this.currentPulseData.taskPulseInfo.fundCode;
                }
                this.taskService.refreshAuditStatus(_param).subscribe(res => {
                }, () => {
                  clearInterval(this.scanAuditTimer);
                  if (column && pulse.columnValues[column.id]) {
                    pulse.columnValues[column.id]['scanAuditStatus'] = false;
                  }
                });
              });
            }
          }
        }, () => {
          clearInterval(this.scanAuditTimer);
          if (column && pulse.columnValues[column.id]) {
            pulse.columnValues[column.id]['scanAuditStatus'] = false;
          }
        });
      }
      if (type === 'single') {
        this.taskService.getBoardPulseScanLog(this.currentPulseData.id, this.taskDataDate).subscribe((res: any) => {
          if (res && res.scanParam) {
            const scanParam = JSON.parse(res.scanParam);
            const auditItemList = scanParam.auditItemList;
            if (auditItemList && auditItemList.length) {
              auditItemList.forEach(_list => {
                if (_list.itemIdList[0] === pulse) {
                  const _param = _list;
                  if (this.currentPulseData.taskPulseInfo && this.currentPulseData.taskPulseInfo.fundCode) {
                    _param['fundCode'] = this.currentPulseData.taskPulseInfo.fundCode;
                  }
                  this.taskService.refreshAuditStatus(_param).subscribe(res => {
                    this.message.create('success', '稽核开始刷新！');
                  }, () => {
                    clearInterval(this.scanAuditTimer);
                    if (column && pulse.columnValues[column.id]) {
                      pulse.columnValues[column.id]['scanAuditStatus'] = false;
                    }
                  });
                }
              });
            }
          }
        }, () => {
          clearInterval(this.scanAuditTimer);
          if (column && pulse.columnValues[column.id]) {
            pulse.columnValues[column.id]['scanAuditStatus'] = false;
          }
        });
      }
    }
    // 处理扫描状态
    if (column && pulse.columnValues[column.id]) {
      pulse.columnValues[column.id]['scanAuditStatus'] = true;
      this.pollingScanStatus();
    }
  }
  // 刷新监控
  refreshMonitor(event, pulse, column, type) {
    // 前置任务处理
    const preTaskId = pulse.preTaskDefId ? pulse.preTaskDefId.split(',') : [];
    if (pulse.taskDef && pulse.taskDef.preTaskDefId) {
      const backVal = this.preTaskHandle(this.boardPulseData, preTaskId);
      if (!backVal.status) {
        this.message.create('warning', '请先完成前置任务：' + backVal.title);
        return false;
      }
    }
    this.taskDataDate = localStorage.getItem('taskDataDate');
    if (event) {
      event.stopPropagation();
    }
    if (pulse && type === 'all') {
      this.currentPulseData = pulse;
    }
    if (column && type === 'all') {
      this.currentColumnData = column;
    }
    if (this.currentPulseData && this.currentColumnData && this.currentPulseData.columnValues[this.currentColumnData.id]) {
      this.currentPulseData.columnValues[this.currentColumnData.id] = {
        scanStatus: null
      }
    }
    let idList: any;
    const param = {
      dataDate: this.taskDataDate,
      reloadData: '1'
    };
    if (type === 'all') {
      if (this.currentPulseData.taskDef.indicatorItemIdList) {
        this.indicatorItemIdList = this.currentPulseData.taskDef.indicatorItemIdList;
        idList = this.indicatorItemIdList.join(',');
        param['itemIdList'] = this.indicatorItemIdList;
      }
    }
    if (pulse && type === 'single') {
      param['itemIdList'] = [pulse];
      idList = pulse;
    }
    const today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    if (today <= this.taskDataDate) {
      // 当天取监控后台日期
      this.taskService.getRefreshTodayIndicatorDate({idList: idList}).subscribe((res: any) => {
        if (res) {
          const paramArr = [];
          for (const i in res) {
            if (res.hasOwnProperty(i) && res[i]) {
              this.refreshTodayMonitor(i, res[i], type);
              const _param = {
                itemIdList: [i],
                dataDate: res[i],
                reloadData: '1'
              };
              paramArr.push(_param);
            }
          }
          this.postBoardPulseScanLogData(this.taskDataDate, this.currentPulseData.id, {indicatorItemList: paramArr});
        }
      }, () => {
        clearInterval(this.scanAuditTimer);
        if (pulse.columnValues[column.id]) {
          pulse.columnValues[column.id]['scanMonitorStatus'] = false;
        }
      });
    } else {
      // 查询历史监控日期
      if (type === 'all') {
        this.taskService.getBoardPulseScanLog(this.currentPulseData.id, this.taskDataDate).subscribe((res: any) => {
          if (res && res.scanParam) {
            const scanParam = JSON.parse(res.scanParam);
            const indicatorItemList = scanParam.indicatorItemList;
            if (indicatorItemList && indicatorItemList.length) {
              indicatorItemList.forEach(_list => {
                const _param = _list;
                if (this.currentPulseData.taskPulseInfo && this.currentPulseData.taskPulseInfo.fundCode) {
                  _param['fundCode'] = this.currentPulseData.taskPulseInfo.fundCode;
                }
                this.taskService.refreshMonitorStatus(_param).subscribe(res => {
                }, () => {
                  clearInterval(this.scanAuditTimer);
                  if (pulse.columnValues[column.id]) {
                    pulse.columnValues[column.id]['scanMonitorStatus'] = false;
                  }
                });
              });
            }
          }
        }, () => {
          clearInterval(this.scanAuditTimer);
          if (pulse.columnValues[column.id]) {
            pulse.columnValues[column.id]['scanMonitorStatus'] = false;
          }
        });
      }
      if (type === 'single') {
        this.taskService.getBoardPulseScanLog(this.currentPulseData.id, this.taskDataDate).subscribe((res: any) => {
          if (res && res.scanParam) {
            const scanParam = JSON.parse(res.scanParam);
            const indicatorItemList = scanParam.indicatorItemList;
            if (indicatorItemList && indicatorItemList.length) {
              indicatorItemList.forEach(_list => {
                if (_list.itemIdList[0] === pulse) {
                  const _param = _list;
                  if (this.currentPulseData.taskPulseInfo && this.currentPulseData.taskPulseInfo.fundCode) {
                    _param['fundCode'] = this.currentPulseData.taskPulseInfo.fundCode;
                  }
                  this.taskService.refreshMonitorStatus(_param).subscribe(res => {
                    this.message.create('success', '监控开始刷新！');
                  }, () => {
                    clearInterval(this.scanAuditTimer);
                    if (column && pulse.columnValues[column.id]) {
                      pulse.columnValues[column.id]['scanMonitorStatus'] = false;
                    }
                  });
                }
              });
            }
          }
        }, () => {
          clearInterval(this.scanAuditTimer);
          if (column && pulse.columnValues[column.id]) {
            pulse.columnValues[column.id]['scanMonitorStatus'] = false;
          }
        });
      }
    }
    // 处理扫描状态
    if (column && pulse.columnValues[column.id]) {
      pulse.columnValues[column.id]['scanMonitorStatus'] = true;
      this.pollingScanStatus();
    }
  }
  // 稽核结果
  auditResults(pulse, column) {
    // 前置任务处理
    const preTaskId = pulse.preTaskDefId ? pulse.preTaskDefId.split(',') : [];
    if (pulse.taskDef && pulse.taskDef.preTaskDefId) {
      const backVal = this.preTaskHandle(this.boardPulseData, preTaskId);
      if (!backVal.status) {
        this.message.create('warning', '请先完成前置任务：' + backVal.title);
        return false;
      }
    }
    this.taskDataDate = localStorage.getItem('taskDataDate');
    this.currentPulseData = pulse;
    this.currentColumnData = column;
    if (this.currentPulseData.taskDef.auditItemIdList) {
      this.auditItemIdList = this.currentPulseData.taskDef.auditItemIdList;
    }
    this.auditModalVisible = true;
    this.getAuditResult();
  }
  // 监控结果
  monitorResults(pulse, column) {
    // 前置任务处理
    const preTaskId = pulse.preTaskDefId ? pulse.preTaskDefId.split(',') : [];
    if (pulse.taskDef && pulse.taskDef.preTaskDefId) {
      const backVal = this.preTaskHandle(this.boardPulseData, preTaskId);
      if (!backVal.status) {
        this.message.create('warning', '请先完成前置任务：' + backVal.title);
        return false;
      }
    }
    this.taskDataDate = localStorage.getItem('taskDataDate');
    this.currentPulseData = pulse;
    this.currentColumnData = column;
    if (this.currentPulseData.taskDef.indicatorItemIdList) {
      this.indicatorItemIdList = this.currentPulseData.taskDef.indicatorItemIdList;
    }
    this.monitorModalVisible = true;
    this.getIndicatorResult();
  }
  // 报表预览
  reportPreview(pulse) {
    const date = this.taskDataDate.replace(/^(\d{4})-(\d{2})-(\d{2})$/, '$1$2$3');
    if (pulse.taskDef && pulse.taskDef.taskReportConfig) {
      this.taskReportConfig = pulse.taskDef.taskReportConfig;
      const param = {
        reportId: this.taskReportConfig[0].reportId,
        dateValue: date,
        reportFormType: '1'
      };
      this.taskService.reportView(param).subscribe(result => {
        let url;
        const blob = new Blob([result], {type: 'application/pdf'});
        url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
      });
    }
  }
  // 报表下载
  reportExport(pulse) {
    if (pulse.taskDef && pulse.taskDef.taskReportConfig) {
      this.taskReportConfig = pulse.taskDef.taskReportConfig;
      const token = localStorage.getItem('id').split('Bearer ')[1];
      const date = this.taskDataDate.replace(/^(\d{4})-(\d{2})-(\d{2})$/, '$1$2$3');
      const datasourceBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('datasourceModule') && SERVICE_CONFIG.environment['datasourceModule'] ? SERVICE_CONFIG.environment['datasourceModule'] : '';
      const url = datasourceBaseApi + '/v1/excel_report/export/' + this.taskReportConfig[0].reportId
        + '?reportFormType=1'
        + '&dateValue=' + date
        + '&jtoken=' +  token;
      window.open(url, '_blank');
    }
  }
  // 稽核检查项查看
  openAuditDetail(data) {
    if (!data.latestExecutionId) { return; }
    this.checkVisible = true;
    this.checkList.executionId = data.latestExecutionId;
    this.checkList.isQueryCollapsed = true;
    this.checkList.params = {};
    // this.checkList.setCondition();
    this.checkList.getColumsList();
    this.checkList.getTotal();
    this.checkList.listenerScroll();
  }
  // 导出excel
  exportMonitorExcel() {
    this.ratioSuperisory.exportHandle();
  }
  getOutSystemName(outSystemCode) {
    return this.outSystems.hasOwnProperty(outSystemCode) ? this.outSystems[outSystemCode] : '';
  }
  // 获取稽核项状态
  getAuditResult() {
    this.auditList = [];
    const today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    if (today <= this.taskDataDate) {
      this.taskService.getRefreshTodayAuditDate({idList: this.auditItemIdList.join(',')}).subscribe((res: any) => {
        let _date: any;
        if (res) {
          for (const i in res) {
            _date = res[i];
          }
          const param = {
            itemIdList: this.auditItemIdList,
            dataDate: _date
          };
          if (this.currentPulseData.taskPulseInfo && this.currentPulseData.taskPulseInfo.fundCode) {
            param['fundCode'] = this.currentPulseData.taskPulseInfo.fundCode;
          }
          this.taskService.getAuditList(param).subscribe( list => {
            this.auditList = list ? list : [];
            this.auditList.forEach( item => {
              item['progress'] = item['progress'] ? this.utilsModule.accMul(item['progress'], 100) : '0';
              if (item.schedule) {
                item.schedule = JSON.parse(item.schedule);
              } else {
                item['schedule'] = {
                  schedulerDescription: item.lastExecuteTime ? this.utilsModule.timeFormat(item.lastExecuteTime) : this.taskDataDate
                };
              }
            });
          });
        }
      });
    } else {
      // 查询历史稽核日期
      this.taskService.getBoardPulseScanLog(this.currentPulseData.id, this.taskDataDate).subscribe((res: any) => {
        if (res && res.scanParam) {
          const scanParam = JSON.parse(res.scanParam);
          const auditItemList = scanParam.auditItemList;
          if (auditItemList) {
            const param = {
              itemIdList: this.auditItemIdList,
              dataDate: auditItemList[0].dataDate
            };
            if (this.currentPulseData.taskPulseInfo && this.currentPulseData.taskPulseInfo.fundCode) {
              param['fundCode'] = this.currentPulseData.taskPulseInfo.fundCode;
            }
            this.taskService.getAuditList(param).subscribe( list => {
              this.auditList = list ? list : [];
              this.auditList.forEach( item => {
                item['progress'] = item['progress'] ? this.utilsModule.accMul(item['progress'], 100) : '0';
                if (item.schedule) {
                  item.schedule = JSON.parse(item.schedule);
                } else {
                  item['schedule'] = {
                    schedulerDescription: item.lastExecuteTime ? this.utilsModule.timeFormat(item.lastExecuteTime) : this.taskDataDate
                  };
                }
              });
            });
          }
        }
      });
    }
  }
  // 获取监控项状态
  getIndicatorResult() {
    this.monitorList = [];
    const today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    if (today <= this.taskDataDate) {
      this.taskService.getRefreshTodayIndicatorDate({idList: this.indicatorItemIdList.join(',')}).subscribe((res: any) => {
        let _date: any;
        if (res) {
          for (const i in res) {
            _date = res[i];
          }
          const param = {
            itemIdList: this.indicatorItemIdList,
            dataDate: _date
          };
          if (this.currentPulseData.taskPulseInfo && this.currentPulseData.taskPulseInfo.fundCode) {
            param['fundCode'] = this.currentPulseData.taskPulseInfo.fundCode;
          }
          this.taskService.getSupervisoryList(param).subscribe( list => {
            this.monitorList = list ? list : [];
            this.monitorList.forEach( item => {
              item['progress'] = item['progress'] ? this.utilsModule.accMul(item['progress'], 100) : '0';
              if (item.schedule) {
                item.schedule = JSON.parse(item.schedule);
              } else {
                item['schedule'] = {
                  schedulerDescription: item.lastExecuteTime ? this.utilsModule.timeFormat(item.lastExecuteTime) : this.taskDataDate
                };
              }
            });
          });
        }
      });
    } else {
      // 查询历史监控日期
      this.taskService.getBoardPulseScanLog(this.currentPulseData.id, this.taskDataDate).subscribe((res: any) => {
        if (res && res.scanParam) {
          const scanParam = JSON.parse(res.scanParam);
          const indicatorItemList = scanParam.indicatorItemList;
          if (indicatorItemList) {
            const param = {
              itemIdList: this.indicatorItemIdList,
              dataDate: indicatorItemList[0].dataDate
            };
            if (this.currentPulseData.taskPulseInfo && this.currentPulseData.taskPulseInfo.fundCode) {
              param['fundCode'] = this.currentPulseData.taskPulseInfo.fundCode;
            }
            this.taskService.getSupervisoryList(param).subscribe( list => {
              this.monitorList = list ? list : [];
              this.monitorList.forEach( item => {
                item['progress'] = item['progress'] ? this.utilsModule.accMul(item['progress'], 100) : '0';
                if (item.schedule) {
                  item.schedule = JSON.parse(item.schedule);
                } else {
                  item['schedule'] = {
                    schedulerDescription: item.lastExecuteTime ? this.utilsModule.timeFormat(item.lastExecuteTime) : this.taskDataDate
                  };
                }
              });
            });
          }
        }
      });
    }
  }
  // 当天刷新稽核
  refreshTodayAudit(id, dataDate, type) {
    const _param = {
      itemIdList: [id],
      dataDate: dataDate,
      reloadData: '1'
    };
    if (this.currentPulseData.taskPulseInfo && this.currentPulseData.taskPulseInfo.fundCode) {
      _param['fundCode'] = this.currentPulseData.taskPulseInfo.fundCode;
    }
    this.taskService.refreshAuditStatus(_param).subscribe(res => {
      if (type === 'single') {
        this.message.create('success', '稽核开始刷新！');
      }
    }, () => {
      clearInterval(this.scanAuditTimer);
      if (this.currentPulseData.columnValues[this.currentColumnData.id]) {
        this.currentPulseData.columnValues[this.currentColumnData.id]['scanAuditStatus'] = false;
      }
    });
  }
  // 保存刷新稽核监控记录
  postBoardPulseScanLogData(date, pulseId, param) {
    const params = {
      scanDate: date,
      pulseId: pulseId,
      scanParam: param
    };
    this.taskService.postBoardPulseScanLog(params).subscribe(res => {});
  }
  // 当天刷新监控
  refreshTodayMonitor(id, dataDate, type) {
    const _param = {
      itemIdList: [id],
      dataDate: dataDate,
      reloadData: '1'
    };
    if (this.currentPulseData.taskPulseInfo && this.currentPulseData.taskPulseInfo.fundCode) {
      _param['fundCode'] = this.currentPulseData.taskPulseInfo.fundCode;
    }
    this.taskService.refreshMonitorStatus(_param).subscribe(res => {
      if (type === 'single') {
        this.message.create('success', '监控开始刷新！');
      }
    }, () => {
      clearInterval(this.scanAuditTimer);
      if (this.currentPulseData.columnValues[this.currentColumnData.id]) {
        this.currentPulseData.columnValues[this.currentColumnData.id]['scanMonitorStatus'] = false;
      }
    });
  }
  // 轮询扫描状态
  pollingScanStatus() {
    this.scanAuditTimer = setInterval( () => {
      if (this.currentPulseData.columnValues[this.currentColumnData.id] && this.currentPulseData.columnValues[this.currentColumnData.id].scanStatus === 'success') {
        this.currentPulseData.columnValues[this.currentColumnData.id]['scanAuditStatus'] = false;
        this.currentPulseData.columnValues[this.currentColumnData.id]['scanMonitorStatus'] = false;
        clearInterval(this.scanAuditTimer);
      }
    }, 3000);
  }
  // 稽核检查项详情-取消
  checkCancle() {
    this.checkList.show = false;
    this.checkVisible = false;
    this.checkList.emptyForm();
  }
  // 导出excel
  exportExcel() {
    this.checkList.exportHandle();
  }
  // 发送提醒
  sendWarned(type) {
    if (type === 'all') { // 发送全部
      this.ratioSuperisory.ids = [];
      this.ratioSuperisory.warnedComponent.ids = [];
      this.ratioSuperisory.warnedVisible = true;
      this.ratioSuperisory.initWarnedField();
      this.ratioSuperisory.warnedComponent.initWarned();
    } else { // 发送选择
      const ids = this.ratioSuperisory.getCheckedId();
      if (ids && ids.length) {
        this.ratioSuperisory.ids = ids;
        this.ratioSuperisory.warnedComponent.ids = ids;
        this.ratioSuperisory.warnedVisible = true;
        this.ratioSuperisory.initWarnedField();
        this.ratioSuperisory.warnedComponent.initWarned();
      }
    }
  }
  checkMonitorCancle() {
    this.checkMonitorVisible = false;
    this.ratioSuperisory.emptyForm();
  }
  // 监控检查项查看
  openMonitorDetail(data) {
    if (!data.latestExecutionId) { return; }
    this.checkMonitorVisible = true;
    this.ratioSuperisory.datasourceId = data.datasourceId;
    this.ratioSuperisory.executionId = data.latestExecutionId;
    this.ratioSuperisory.warnedComponent.executionId = data.latestExecutionId; // 获取执行id
    this.ratioSuperisory.isQueryCollapsed = true;
    this.ratioSuperisory.params = {};
    this.ratioSuperisory.itemId = data.id;

    this.ratioSuperisory.source = data.source;
    this.ratioSuperisory.outSystemCode = data.outSystem;
    this.ratioSuperisory.outItemId = data.outItemId;

    this.ratioSuperisory.getColumsList();
    this.ratioSuperisory.getTotal();
    this.ratioSuperisory.listenerScroll();
    this.ratioSuperisory.getTemplate();
  }
  checkReportCancle() {
    this.reportVisible = false;
  }
  stopScanAudit(pulse, column) {
    if (pulse.columnValues[column.id]) {
      pulse.columnValues[column.id]['scanAuditStatus'] = false;
    }
  }
  stopScanMonitor(pulse, column) {
    if (pulse.columnValues[column.id]) {
      pulse.columnValues[column.id]['scanMonitorStatus'] = false;
    }
  }
  openPulseDialog(pulse) {
    this.isEditPulseNameVisible = true;
    this.currentPulseData = pulse;
  }
  handleEditPulseNNameOk() {
    const param = {};
    if (this.currentPulseData.name) {
      param['name'] = this.currentPulseData.name;
      this.dataSubscription = this.taskService.doEditPulseName(this.currentPulseData.id, param).subscribe((res: any) => {
        this.message.success('任务名称修改成功！');
        this.isEditPulseNameVisible = false;
        this.editNameId = null;
        this.originalValue = res.name;
      });
    } else {
      this.message.warning('任务名称不能为空！');
    }
  }
  handleEditPulseNameCancel() {
    this.isEditPulseNameVisible = false;
  }
  openEditColumnNameDialog(column) {
    this.currentColumnData = column;
    this.isEditColumnNameVisible = true;
  }
  handleEditColumnNNameOk() {
    if (this.currentColumnData.title) {
      const param = {
        title: this.currentColumnData.title
      };
      this.editNameId = null;
      this.dataSubscription = this.taskService.doEditColumnHeader(this.boardId, this.currentColumnData.id, param).subscribe((res: any) => {
        this.message.success('列名称修改成功！');
        this.isEditColumnNameVisible = false;
      });
    } else {
      this.message.warning('列名称不能为空！');
    }
  }
  handleEditColumnNameCancel() {
    this.isEditColumnNameVisible = false;
  }
  tabSelectedIndexChange(event) {
    localStorage.setItem('tabSelectedIndex', event);
  }
  startEdit(id: string, columnId: string): void {
    this.editId = id + '_' + columnId;
  }
  stopEdit(): void {
    this.editId = null;
  }
  // 手工添加任务
  onTaskDateChange(event) {
    console.log(event)
  }
  // 层级展示切换
  treeGridLevelChange(type, groupId) {
    for (const item in this.mapOfExpandedData) {
      if (this.mapOfExpandedData.hasOwnProperty(item)) {
        this.handleTreeCollapse(this.mapOfExpandedData[item], groupId, type);
      }
    }
    if (type === 'unfold' || type === 'fold') {
      localStorage.setItem('groupFoldStatus', type);
    }
  }
  // 处理树形折叠
  handleTreeCollapse(data: Array<any>, groupId: string, type: any) {
    switch (type) {
      case 'unfold':
        data.forEach(list => {
          if (list.children && list.children.length && list.groupId === groupId) {
            list.expand = true;
          }
        });
        break;
      case 'fold':
        data.forEach(list => {
          if (list.children && list.children.length && list.groupId === groupId) {
            list.expand = false;
          }
        });
        break;
      default:
        data.forEach(list => {
          if (list.children && list.children.length && list.groupId === groupId && list.expand) {
            list.expand = false;
          }
          if (list.groupId === groupId && list.level === type - 1) {
            list.expand = !list.expand;
          }
        });
        break;
    }
  }
  // 获取树形最大层级
  getTreeGridMaxLevel(data: Array<any>, group) {
    data.forEach(item => {
      if (group.levelNumber < item.level) {
        group.levelNumber = item.level;
      }
    });
    for (let i = 0; i < group.levelNumber; i++) {
      const o = {
        id: i + 1,
        title: i + 1 + '级'
      };
      group.levelList.push(o);
    }
    group.levelList = this.duplicateRemoval(group.levelList);
  }
}
